/**
 * Created by Christof Sander on 25.05.2016.
 */

// the Component variable has to be instantiated at runtime to prevent circle dependencies between the Component- and the utils-Class
var Component;
var componentUndefined = true;

// moment must be initialized with timezone
// NOTE: see utils.initMoment(...)
var moment = require('moment-timezone');
var striptags = require('striptags');
var HTMLEntities = require('html-entities').AllHtmlEntities;
var removeDiacritics = require('diacritics').remove;
var crypto = require('crypto');
var kebabCase = require('lodash/kebabCase');

var truncateStringByBytes = require("./utils.truncateStringByBytes");
var getLength = Buffer.byteLength.bind(Buffer);


var SITEMAP_HEADER = '<?xml version="1.0" encoding="UTF-8"?><urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">';
var SITEMAP_FOOTER = '</urlset>';


// TODO: CLEANUP ACTION-CLASS vs PROMISE DEBUG STUFF
// var Action = require('../client/action');

// TODO: DEBUG CLEANUP START
var stats = {
	replaces: 0,
	merges: 0,
	simpleMerges: 0,
	refMerges: 0,
	forEaches: 0
};
// TODO: DEBUG CLEANUP END

// DEFAULT CONSTANTS FALLBACK
if(Number.MAX_SAFE_INTEGER === undefined) Number.MAX_SAFE_INTEGER = 4294967296;
if(Number.MIN_SAFE_INTEGER === undefined) Number.MIN_SAFE_INTEGER = -Number.MAX_SAFE_INTEGER + 2;

var DEFAULT_RENDERED_IMAGE_CODENAME = '__default';


/**
 * this is a static class used to collect common usage functions.
 * at the moment this class will be used in client-side code primarily to prevent the necessity of loading lodash-lib in client-side apps.
 *
 * @author  cs
 * @since   25.5.2016
 * @version 1.0
 */
var utils = {
	$: null,

	getStats: function(){
		return stats;
	},

	getComponentIDByIndex: function(index){
		return 'c_' + String(index).replace(/^-+/, '_');
	},

	///////////////////////////////////////////////
	///// STATUS HELPERS
	///////////////////////////////////////////////

	/**
	 * this function returns if the given element is empty or not
	 *
	 * @param   element
	 * @returns {boolean}
	 */
	isEmpty: function(element){
		return typeof(element) === 'undefined' || element === '' || element === null || element === 0 || element === false || (typeof(element) === 'object' && this.collectionSize(element) === 0);
	},

	/**
	 * this function returns if the given element is a function or not
	 *
	 * @param   element
	 * @returns {boolean}
	 */
	isFunction: function(element){
		return typeof(element) === 'function';
	},

	/**
	 * this function returns true if the given element is an array
	 *
	 * @param   element
	 * @returns {boolean}
	 */
	isArray: function(element){
		return Array.isArray(element);
	},

	/**
	 * this function returns true if the given element is an object
	 *
	 * @param   element
	 * @returns {boolean}
	 */
	isObject: function(element){
		return typeof(element) === 'object' && !Array.isArray(element);
	},

	/**
	 * this function returns true if the given element is an array or an object
	 *
	 * @param   element
	 * @returns {boolean}
	 */
	isCollection: function(element){
		return element !== null && typeof(element) === 'object' || Array.isArray(element);
	},

	/**
	 * this function returns true if the given element is a string
	 *
	 * @param   element
	 * @returns {boolean}
	 */
	isString: function(element){
		return typeof(element) === 'string';
	},

	/**
	 * this function returns true if the given element is a number
	 *
	 * @param   element
	 * @returns {boolean}
	 */
	isNumber: function(element){
		return typeof(element) === 'number';
	},

	/**
	 * this function is used to check if a equals b. in case of arrays or objects all elements will be checked recursive.
	 *
	 * @param a						data element to check for equality
	 * @param b						data element to check for equality
	 * @param isEqualCallback		if this function is defined it will be called with the following parameters in case of a found unEquality ([key], a, b).
	 * 								this function by return true for equal or false otherwise. this way you may define exceptions.
	 * @param callbackIsReady		boolean flag which is used by internal logic only. never set this flag from outside.
	 * @returns {boolean}			true if the elements are equal.
	 */
	isEqual: function(a, b, isEqualCallback, callbackIsReady){
		if(callbackIsReady === undefined) callbackIsReady = typeof isEqualCallback === 'function';

		if(!utils.isCollection(a)){
			if(a !== b){
				if(callbackIsReady) return !!isEqualCallback(undefined, a, b);
				return false;
			}
			return true;
		}
		if(!utils.isCollection(b)){
			if(callbackIsReady) return !!isEqualCallback(undefined, a, b);
			return false
		}

		var equal = true;
		var preventCallback = false;
		var i;
		var keys = {};
		var key;
		var data = [a, b];
		for(i = 0; i < 2; i++){
			for(key in data[i]){
				if(!keys[key]) {
					keys[key] = true;
					preventCallback = false;
					if(!utils.isCollection(a[key])){
						equal &= a[key] === b[key];
					} else if(!utils.isCollection(b[key])){
						equal = false;
					} else {
						preventCallback = true;
						equal &= utils.isEqual(a[key], b[key], isEqualCallback, callbackIsReady);
					}

					if(!equal){
						if(callbackIsReady && !preventCallback){
							if(!isEqualCallback(key, a[key], b[key])){
								return false;
							}
							equal = true;
						} else {
							return false;
						}
					}
				}
			}
		}

		return true;
	},

	/**
	 * returns the number of elements within a collection.
	 * if the given element is no collection ([] | {}) zero will be returned.
	 *
	 * @param   element
	 * @returns int
	 */
	collectionSize: function(element){
		if(Array.isArray(element)){
			return element.length || Object.keys(element).length; // there are special cases where invalid arrays (those using non-numeric indexes) should be recognized. those arrays have length-property = 0 but contain values.
		}
		else if(typeof(element) === 'object' && element !== null){
			return Object.keys(element).length;
		}

		return 0;
	},

	/**
	 * this function returns Object.values in a ES2015 compatible way.
	 *
	 * @param element		[] || {}
	 * @returns {[]}
	 */
	collectionValues: function(element){
		if(!element){
			return [];
		}
		if(Array.isArray(element)){
			return element;
		}
		if(typeof Object.values === 'function'){
			return Object.values(element);
		}

		var result = [];
		for(var e in element){
			result.push(element[e]);
		}
		return result;
	},

	/**
	 * this function returns the first argument which is set in the argument list
	 *
	 * @returns {*}
	 */
	first: function(){
		if(arguments.length > 0) return arguments[0];
		return;
	},


	///////////////////////////////////////////////
	///// COLLECTION OPERATIONS
	///////////////////////////////////////////////

	/**
	 * this function is similar than js-native index of with two essential difference:
	 *      this function uses == rather than === and
	 *      it works with objects
	 *
	 * @param       collection  	[] || {}
	 * @param       element     	element || function(){} => boolean
	 * @param       defaultValue    default: -1
	 * @returns     {number}    	defaultValue if not found and array index of found element otherwise
	 */
	indexOf: function(collection, element, defaultValue = -1){
		var elementIsFunction = typeof(element) === 'function';

		if(Array.isArray(collection)) {
			for (var i = 0; i < collection.length; i++) {
				if (elementIsFunction && element(collection[i], i)) return i;
				if (collection[i] == element) 						return i;
			}
		} else if(typeof(collection) === 'object' && collection !== null){
			var keys = Object.keys(collection);
			for (var i = 0; i < keys.length; i++) {
				if (elementIsFunction && element(collection[i], i)) return keys[i];
				if (collection[keys[i]] == element) 				return keys[i];
			}
		}
		return defaultValue;
	},

	/**
	 * this function is used to perform a well known forEach operation on arrays as well as objects like lodash does
	 *
	 * @param   collection        array | object
	 * @param   elementCallback   function
	 * @returns void
	 */
	forEach: function(collection, elementCallback){
		stats.forEaches++;

		if(typeof(elementCallback) === 'function' && !this.isEmpty(collection)){
			var keys = Object.keys(collection);
			var firstKey = keys[0];
			var lastKey = keys[keys.length - 1];
			for(var index in keys){
				if(elementCallback(collection[keys[index]], keys[index], keys[index] === firstKey, keys[index] === lastKey) === false) break;
			}
		}
	},

	/**
	 * this function is used to perform a well known forEach operation on arrays as well as objects like lodash does.
	 * the only difference is that the list will be traversed backwards.
	 *
	 * @param   collection        array | object
	 * @param   elementCallback   function
	 * @returns void
	 */
	forEachReverse: function(collection, elementCallback){
		stats.forEaches++;

		if(typeof(elementCallback) === 'function' && !this.isEmpty(collection)){
			var keys = Object.keys(collection);
			var firstKey = keys[0];
			var lastKey = keys[keys.length - 1];
			for(var index = keys.length - 1; index >= 0; index--){
				if(elementCallback(collection[keys[index]], keys[index], keys[index] === firstKey, keys[index] === lastKey) === false) break;
			}
		}
	},

	/**
	 * this function is used like forEach but will traverse all elements within the given collection recursive
	 *
	 * @param   collection          array | object
	 * @param   elementCallback     function(value, key, collection, valueIsCollection)
	 * @param   checksDone          boolean - internal var only! are all necessary checks done
	 */
	forAll: function(collection, elementCallback, checksDone){
		if((checksDone || typeof(elementCallback) === 'function') && collection){
			var keys = Object.keys(collection);
			var result, index;
			var isCollection = false;
			for(index in keys){
				isCollection = utils.isCollection(collection[keys[index]]);
				result = elementCallback(collection[keys[index]], keys[index], collection, isCollection);
				if(result === 'break') return result;
				if(result !== 'breakRecursion' && isCollection){
					var childResult = utils.forAll(collection[keys[index]], elementCallback, true);
					if(childResult === 'break') return childResult;
				}
			}
		}
	},

	/**
	 * this function is used to perform a well known map operation on arrays as well as objects like lodash does
	 *
	 * @param   collection        array | object
	 * @param   elementCallback   function
	 * @returns collection containing referential replaced values within original collection
	 */
	map: function(collection, elementCallback){
		if(typeof(elementCallback) === 'function' && !this.isEmpty(collection)){
			var keys = Object.keys(collection);
			for(var index in keys){
				collection[keys[index]] = elementCallback(collection[keys[index]], keys[index]);
			}
		}
	},

	/**
	 * this function behaves very similar to map() but does not change the original collection
	 *
	 * @param   collection        array | object
	 * @param   elementCallback   function
	 * @returns collection containing new values
	 */
	mapValue: function(collection, elementCallback){
		if(typeof(elementCallback) === 'function' && !this.isEmpty(collection)){
			var newCollection = {};
			if(utils.isArray(collection)) newCollection = [];
			var keys = Object.keys(collection);
			for(var index in keys){
				newCollection[keys[index]] = elementCallback(collection[keys[index]], keys[index]);
			}
		}

		return newCollection;
	},

	/**
	 * this function is used to perform a well known map operation on arrays as well as objects like lodash does.
	 *
	 * @param   collection          array | object
	 * @param   elementCallback     function
	 * @param   checksDone          boolean - internal var only! are all necessary checks done
	 * @returns void
	 */
	mapAll: function(collection, elementCallback, checksDone){
		if(checksDone || (typeof(elementCallback) === 'function' && !this.isEmpty(collection))){
			var keys = Object.keys(collection);
			var newValue;
			var i;
			var index;
			var deletionIndex = 0;
			var isArray = Array.isArray(collection);
			for(i in keys){
				if(isArray) index = keys[i] - deletionIndex;
				else 		index = keys[i];
				if(utils.isCollection(collection[index])) collection[index] = utils.mapAll(collection[index], elementCallback, true);
				if((newValue = elementCallback(collection[index], index)) === undefined){
					if(isArray){
						collection.splice(index, 1);
						deletionIndex++;
					}
					else{
						delete collection[index];
					}
				}
				else {
					collection[index] = newValue;
				}
			}
		}

		return collection;
	},

	/**
	 * this function is used to concat all given parameter-arrays without changing any of them.
	 *
	 * @returns {Array}
	 */
	concat: function(){
		var result = [];
		var a, f;
		for(a in arguments){
			if(Array.isArray(arguments[a])){
				for(f in arguments[a]){
					result.push(arguments[a][f]);
				}
			}
		}
		// this.forEach(arguments, function(element){
		// 	if(Array.isArray(element)){
		// 		utils.forEach(element, function(fields) {
		// 			result.push(fields);
		// 		});
		// 	}
		// });
	    return result;
	},


	/**
	 * this function is used to merge multiple collections to one object where the right argument overwrites the left argument and the process order is from left to right.
	 * NOTE: this variant respects component-classes
	 * TODO: duplicate merge function solution needed!
	 * TODO: CLEANUP
	 *
	 * @returns {{}}
	 */
	merge: function(){
		stats.merges++;

	    if(componentUndefined){
            componentUndefined = false;
            Component = require('./component');
        }

		var result = {};
		var start = 0;
		var a, f, fL, fK, field, fieldIndex;

		for(a = 0; a < arguments.length; a++){
			if(!utils.isEmpty(arguments[a])){
				if (arguments[a] === null)                  result = null;
				else if (Array.isArray(arguments[a]))       result = [];
				else if (arguments[a] instanceof Component) result = new Component(undefined, arguments[a].requestID, arguments[a].sessionID);
				else if (typeof arguments[a] === 'string') 	result = '' + arguments[a];
				else if (typeof arguments[a] !== 'object') 	result = arguments[a];
				break;
			}
		}

		var sourceIsArray,
			sourceIsNull,
			sourceIsSimple;

		for(a = start; a < arguments.length; a++){
			if(typeof arguments[a] === 'object' && arguments[a] != null){
				fK = Object.keys(arguments[a]);
				fL = fK.length;
				for(f = 0; f < fL; f++){
					fieldIndex = fK[f];
					field = arguments[a][fieldIndex];
					sourceIsArray = Array.isArray(field);
					sourceIsNull = field === null;
					sourceIsSimple = !sourceIsArray && (typeof(field) !== 'object' || sourceIsNull || (utils.$ && field instanceof utils.$) || field instanceof Component);

					// simple source value => set
					if(sourceIsSimple){
						result[fieldIndex] = field;
					}
					else {
						// empty target => init target according to source type
						if(utils.isEmpty(result[fieldIndex])) {
							if (sourceIsArray)          result[fieldIndex] = [];
							else if (sourceIsNull)      result[fieldIndex] = null;
							else                        result[fieldIndex] = {};
						}
	
						// source is filled collection 
						if(!utils.isEmpty(field)){
							if(typeof(result[fieldIndex]) !== 'object' || result[fieldIndex] === null)  result[fieldIndex] = field;
							else                                                                        result[fieldIndex] = utils.merge(result[fieldIndex], field);
						}
					}
				}
			}
		}

		return result;
	},

	/**
	 * this function is used to merge multiple collections to one object where the right argument overwrites the left argument and the process order is from left to right.
	 *
	 * @returns {{}}
	 */
	simpleMerge: function(){
		stats.simpleMerges++;

		var result = {};
		var a;

		for(a = 0; a < arguments.length; a++){
			if(!utils.isEmpty(arguments[a])){
				if (arguments[a] === null)                  result = null;
				else if (Array.isArray(arguments[a]))       result = [];
				break;
			}
		}

		var f, fK, fL, fieldIndex, field;
		var sourceIsArray, sourceIsNull, sourceIsSimple;

		for(a = 0; a < arguments.length; a++){
			if(typeof arguments[a] === 'object' && arguments[a] != null){
				fK = Object.keys(arguments[a]);
				fL = fK.length;
				for(f = 0; f < fL; f++){

					fieldIndex = fK[f];
					field = arguments[a][fieldIndex];

					sourceIsArray = Array.isArray(field);
					sourceIsNull = field === null;
					sourceIsSimple = !sourceIsArray && (typeof(field) !== 'object' || sourceIsNull);

					// simple source value => set
					if(sourceIsSimple){
						result[fieldIndex] = field;
					}
					else {
						// empty target => init target according to source type
						if(utils.isEmpty(result[fieldIndex])) {
							if (sourceIsArray)          result[fieldIndex] = [];
							else if (sourceIsNull)      result[fieldIndex] = null;
							else                        result[fieldIndex] = {};
						}

						// source is filled collection
						if(!utils.isEmpty(field)){
							if(typeof(result[fieldIndex]) !== 'object' || result[fieldIndex] === null)  result[fieldIndex] = field;
							else                                                                        result[fieldIndex] = utils.simpleMerge(result[fieldIndex], field);
						}
					}
				}
			}
		}

		return result;
	},

	/**
	 * this function works pretty much like utils.merge but uses the first argument as reference.
	 */
	refMerge: function(){
		stats.refMerges++;

		if(arguments.length < 2) return;

		var a;
		var result = arguments[0];
		var f, fK, fL, fieldIndex, field;

		for(a = 1; a < arguments.length; a++){
			if(typeof arguments[a] === 'object' && arguments[a] != null){
				fK = Object.keys(arguments[a]);
				fL = fK.length;
				for(f = 0; f < fL; f++){

					fieldIndex = fK[f];
					field = arguments[a][fieldIndex];

					var sourceIsArray = Array.isArray(field);
					var sourceIsNull = field === null;
					var sourceIsSimple = !sourceIsArray && (typeof(field) !== 'object' || sourceIsNull);

					// simple source value => set
					if(sourceIsSimple){
						result[fieldIndex] = field;
					}
					else {
						// empty target => init target according to source type
						if(utils.isEmpty(result[fieldIndex])) {
							if (sourceIsArray)          result[fieldIndex] = [];
							else if (sourceIsNull)      result[fieldIndex] = null;
							else                        result[fieldIndex] = {};
						}

						// source is filled collection
						if(!utils.isEmpty(field)){
							if(typeof(result[fieldIndex]) !== 'object' || result[fieldIndex] === null)  result[fieldIndex] = field;
							else                                                                        utils.refMerge(result[fieldIndex], field);
						}
					}
				}
			}
		}
	},

	/**
	 * this function is used to replace all items of multiple collections to one object where the right argument overwrites the left argument and the process order is from left to right.
	 *
	 * @returns {{}}
	 */
	replace: function(){
		stats.replaces++;

        if(componentUndefined){
            componentUndefined = false;
            Component = require('./component');
        }

		var result = {};
		var a;
		for(a = 0; a < arguments.length; a++){
			if(!utils.isEmpty(arguments[a])){
				if (arguments[a] === null)                  result = null;
				else if (Array.isArray(arguments[a]))       result = [];
				else if (arguments[a] instanceof Component) result = new Component(undefined, arguments[a].requestID, arguments[a].sessionID);
				break;
			}
		}

		this.forEach(arguments, function(collection){
			utils.forEach(collection, function(field, fieldIndex){
				if(field === undefined) delete result[fieldIndex];
				else 					result[fieldIndex] = field;
			});
		});

		return result;
	},

	/**
	 * this function works just like replace except undefined attributes will not be deleted but set undefined instead.
	 *
	 * @returns {{}}
	 */
	fullReplace: function(){
		stats.replaces++;

        if(componentUndefined){
            componentUndefined = false;
            Component = require('./component');
        }

		var result = {};
		var a;
		for(a = 0; a < arguments.length; a++){
			if(!utils.isEmpty(arguments[a])){
				if (arguments[a] === null)                  result = null;
				else if (Array.isArray(arguments[a]))       result = [];
				else if (arguments[a] instanceof Component) result = new Component(undefined, arguments[a].requestID, arguments[a].sessionID);
				break;
			}
		}

		this.forEach(arguments, function(collection){
			utils.forEach(collection, function(field, fieldIndex){
				result[fieldIndex] = field;
			});
		});

		return result;
	},

	/**
	 * this function works pretty much like utils.replace but uses the first argument as reference.
	 */
	refReplace: function(){
		if(arguments.length < 2) return;

		var a;
		var result = arguments[0];

		for(a = 1; a < arguments.length; a++) {
			utils.forEach(arguments[a], function (field, fieldIndex) {
				if(field === undefined) delete result[fieldIndex];
				else 					result[fieldIndex] = field;
			});
		}
	},

	/**
	 * this function is used to remove all items identified by multiple collections' elements' keys within the first collection given.
	 *
	 * @param element, ...
	 * @returns firstArgument mixed (can be a collection of elements without the keys of the given arguments
	 */
	remove: function(){
		var result = this.copy(arguments[0]);
		if(this.isCollection(result) && arguments.length > 1){
			for(var a = 1; a < arguments.length; a++){
				utils.forEach(arguments[a], function(field, fieldIndex){
					delete result[fieldIndex];
				});
			}
		}

		return result;
	},

	/**
	 * this method is used for simply get a copy of an element.
	 *
	 * @param element
	 * @returns mixed
	 */
	copy: function(){
		return this.merge(arguments[0]);
	},

	/**
	 * supports primitives objects and arrays only but is tremendously faster than a copy or merge.
	 * @param value
	 * @returns {{}|Array|*}
	 */
	simpleCopy: function(value) {
		// return simple value
		if (typeof value !== 'object' || value === null) {
			return value;
		}

		var newValue, i;
		// copy array
		if (value instanceof Array) {
			var l;
			newValue = [];
			for (i = 0, l = value.length; i < l; i++) {
				newValue[i] = utils.simpleCopy(value[i]);
			}
			return newValue;
		}

		// copy object
		newValue = {};
		for (i in value) {
			if (value.hasOwnProperty(i)) {
				newValue[i] = utils.simpleCopy(value[i]);
			}
		}
		return newValue;
	},

	/**
	 * works just like simpleCopy but uses the given reference as a target.
	 * NOTE: 	simpleCopy supports primitive types on the first level.
	 * 			refSimpleCopy has to have objects within the first level
	 * 			of target and value for the referential addressing to work.
	 *
	 * @param target		{} - referential target
	 * @param value			{} - value to be copied to target.
	 * @returns void
	 */
	refSimpleCopy: function(target, value) {
		if(
			typeof target === 'object' && target !== null && !(target instanceof Array)
			&&
			typeof value === 'object' && value !== null && !(value instanceof Array)
		){
			refSimpleCopy({ target: target }, value, 'target');
		} else {
			throw new Error('refSimpleCopy() - MISSING OBJECT');
		}
	},

	/**
	 * this function is used to get a value which is reachable by a cascade of keys within a collection.
	 *
	 * @param   collection  		{} | [] - array or object which should contain the key cascade
	 * @param   keys        		[] - list of keys within the wanted cascade.
	 * @param   recursiveCall		boolean - is this a recursive call
	 * 								NOTE: for internal usage only!
	 * @returns {*} - collection value according to the given keys or undefined if the wanted value does not exist.
	 */
	getCollectionValue: function(collection, keys, recursiveCall){
		if(utils.isEmpty(collection) || utils.isEmpty(keys) || !utils.isArray(keys)) return undefined;
		if(!recursiveCall) keys = utils.collectionValues(keys);
		var key = keys.shift();

		if(key !== 0 && utils.isEmpty(key))             return undefined;
		if(typeof(collection[key]) === 'undefined')     return undefined;
		if(keys.length <= 0)                            return collection[key];
		if(!utils.isCollection(collection[key]))        return undefined;

		return utils.getCollectionValue(collection[key], keys, true);
	},

	/**
	 * this function is used to set a value which is reachable by a cascade of keys within a collection.
	 *
	 * @param   collection  		{} | [] - array or object which should contain the key cascade
	 * @param   keys        		[] - list of keys within the wanted cascade.
	 * @param   value       		mixed - this is the value which should replace the existing value behind the key cascade within the collection.
	 * @param   recursiveCall		boolean - is this a recursive call
	 * 								NOTE: for internal usage only!
	 * @returns true - in success case or throws an error object
	 */
	setCollectionValue: function(collection, keys, value, recursiveCall){
		if(!utils.isCollection(collection) || utils.isEmpty(keys) || !utils.isArray(keys)) throw new Error('utils.setCollectionValue() - invalid call!');
		if(!recursiveCall) keys = utils.collectionValues(keys);

		var key = keys.shift();

		if(key !== 0 && utils.isEmpty(key)) throw new Error('utils.setCollectionValue() - invalid key!');
		if(keys.length <= 0){
			collection[key] = value;
			return true;
		}

		if(typeof(collection[key]) === 'undefined'){
			collection[key] = {};
		}

		utils.setCollectionValue(collection[key], keys, value, true);
		return true;
	},

	promise: {
		/**
		 * this is a wrapper function for jquery-promise resolve
		 *
		 * @param   resolveData     {} - this is the optional data flag which should be resolved. default: {}
		 * @returns {*|{resolve}}
		 */
		resolve: function(resolveData){
			var deferred = (utils.$ || window.$).Deferred();
			deferred.resolve(resolveData || {});
			return deferred.promise();
		},

		/**
		 * this is a wrapper function for jquery-promise resolve
		 *
		 * @param   rejectData     {} - this is the optional data flag which should be resolved. default: {}
		 * @returns {*|{resolve}}
		 */
		reject: function(rejectData){
			// return promise
			var fallback = (utils.$ || window.$).Deferred();
			fallback.reject(rejectData || {});
			return fallback.promise();
		},

		/**
		 * this function is used to abort a promise chain without breaking the used promise-callback-functions usage afterwards.
		 * TODO: check which functions should also be overwritten.
		 *
		 * @return Pseudo-Promise doing nothing except for always
		 */
		abort: function(abortionData){

			var fallback = (utils.$ || window.$).Deferred();
			fallback.reject(abortionData || {});
			var promise = fallback.promise();

			promise.then = function(){};
			promise.fail = function(){};
			promise.done = function(){};

			return promise;
		},

		/**
		 * this function is used to perform an independent list of promises given in chain-parameter one after another.
		 * NOTE: in difference to performAll this function does NOT perform the given promises in parallel.
		 *
		 * @param   chain       [] - list of functions which return a promise
		 * @returns Promise
		 */
		performChain: function(chain){
			if(chain === undefined) chain = [];
			if(chain.length > 0){
				var element = chain.shift(chain);
				if(utils.isFunction(element)) {
					return element().then(function () {
						utils.promise.performChain(chain);
					});
				}
				else {
					// TODO: throw error
					console.error('perform chain has found an element which is not a function');
				}
			}

			return utils.promise.resolve();
		},

		/**
		 * this function is used to perform an independent list of promises given in chain-parameter.
		 * NOTE: this function performs all promises within chain-parameter in parallel.
		 * NOTE: this function is based on jquerys $.when
		 *
		 * @param   context     {} - context object which should perform $.when
		 * @param   chain       [] - list of promises
		 * @returns Promise
		 */
		performAll: function(context, chain){
			if(chain === undefined) chain = [];
			if(context !== undefined && chain.length > 0) {
				return utils.$.when.apply(context, chain);
			}
			return utils.promise.resolve();
		},

		/**
		 * this function is used to perform an action chain of lists of parallel executable actions.
		 *
		 * @param   context         Component - context of promise execution
		 * @param   chain           action chain
		 *                          {
		 *                              <key>: [ <Promise> || function(){ return <Promise>; }, ... ],
	     *                              ...
	     *                          }
		 * @param   bulkIndex       int - actual bulkIndex
		 *                          NOTE: this index is used for internal function calls and must not be set by external ones!!
		 * @returns Promise
		 */
		performAllChains: function(context, chain, bulkIndex){
			bulkIndex = bulkIndex || 0;
			var bulkKeys = Object.keys(chain);
			var bulkKey = bulkKeys[bulkIndex];

			if(!utils.isEmpty(chain[bulkKey])){
				utils.map(chain[bulkKey], function(element){ return (utils.isFunction(element) ? element() : element); });
				return utils.promise.performAll(context, chain[bulkKey]).then(function(resolveData){
					chain[bulkKey] = resolveData;
					return utils.promise.performAllChains(context, chain, bulkIndex + 1);
				});
			}

			// ignore emptyChain?
			if(bulkIndex < (bulkKeys.length - 1)){
				return utils.promise.performAllChains(context, chain, bulkIndex + 1);
			}

			return utils.promise.resolve(chain);
		}
	},

	media: {
		/**
		 * this function will be called when a public media is requested from the app
		 *
		 * @param res       {} - express response object
		 */
		setHeaders: function(res){
			res.setHeader('Expires', '365d');
			res.setHeader('Pragma', 'public');
			res.setHeader('Cache-Control', 'public');
		},

		/**
		 * this function is used to get the mediaData according to index driven dataJSON of a media-image.
		 *
		 * @param   dataJSON        {} - dataJSON field of media-image
		 * @param   mediaID         int - wanted mediaID
		 * @return  undefined | {} - mediaData
		 */
		getMediaDataByID: function(dataJSON, mediaID){
			var mediaData;
			utils.forEach(dataJSON, function(image){
				if(image.mediaID == mediaID){
					mediaData = image;
					return false;
				}
			});

			return mediaData;
		},

		/**
		 * this function is used to return the given image-title for in-url-usage.
		 *
		 * @param   title       string - original image title
		 * @return  string - url ready image title
		 */
		getUrlReadyTitle: function(title){
			return String(removeDiacritics(String(title || '')))
				.toLowerCase()
				.replace(/[^a-z0-9-]+/gi, '-')
				.replace(/[-]+/g, '-')
				.replace(/^-+/, '')
				.replace(/-+$/, '')
			;
		},

		file: {

			/**
			 * prepare media according to the given resource data flag.
			 * NOTE: this function manipulates the media param by reference!
			 *
			 * @param media				{} - mediaData according to resourceTemplates like getCategorizedFiles, getCategorizedFilesFull
			 * 							e.g., { attributes: { mediaID: 13, ... }, children: { ... }}
			 * @param storage			{} - actual storage
			 * @param useOwnConfig		boolean - should the service own config be used?
			 */
			prepare: function(media, storage, useOwnConfig){
				// init
				if(media === undefined) 		media = {};
				if(useOwnConfig === undefined) 	useOwnConfig = true;

				// media config
				var activeServiceMediaConfig;
				if(useOwnConfig){
					if(((((storage || {}).app || {}).service || {}).config || {}).media) {
						activeServiceMediaConfig = utils.simpleCopy(storage.app.service.config.media);
					} else {
						console.error('service media config not found');
						return false;
					}
				} else {
					if(((((storage || {}).app || {}).webService || {}).config || {}).media) {
						activeServiceMediaConfig = utils.simpleCopy(storage.app.webService.config.media);
					} else {
						console.error('assigned service media config not found');
						return false;
					}
				}

				var ownServiceUrl = '';
				if(((storage.app || {}).service || {}).url){
					ownServiceUrl = storage.app.service.url;
				}

				// overwrite media url in developer mode to use fallback according to real used url if necessary
				if((storage.app.service || {}).developerMode && storage.requestUrl){
					activeServiceMediaConfig.url = storage.requestUrl;
				}

				var langCode = 'de-at';
				if(((storage.user || {}).data || {}).langCode){
					langCode = storage.user.data.langCode;
				}

				// define image name without extension if necessary
				var mediaAttributes = media.attributes || {};
				if(mediaAttributes.originalName) {
					var nameParts = String(mediaAttributes.originalName).split('.');
					if(nameParts.length > 1){
						// remove extension
						nameParts.pop();
					}
					// get image name without any dots (dots are not allowed to prevent nginx redirect errors)
					mediaAttributes.name = nameParts.join('.');
				} else {
					console.error('originalName not found in file');
				}

				// prepare media data flags
				var mediaLangAttributes = {};

				// prepare original media's lang data
				if((mediaAttributes.cms_mediaTrl || {})[langCode]){
					mediaLangAttributes = mediaAttributes.cms_mediaTrl[langCode];

					// override lang dependent fields
					if(mediaLangAttributes.name) 		mediaAttributes.name = mediaLangAttributes.name;
					if(mediaLangAttributes.title) 		mediaAttributes.title = mediaLangAttributes.title;
					if(mediaLangAttributes.alt) 		mediaAttributes.alt = mediaLangAttributes.alt;
					if(mediaLangAttributes.info) 		mediaAttributes.info = mediaLangAttributes.info;
					if(mediaLangAttributes.description) mediaAttributes.description = mediaLangAttributes.description;
				}

				utils.media.file.prepareUrls(mediaAttributes, activeServiceMediaConfig, ownServiceUrl);

				// prepare tags
				mediaAttributes.tagsResources = ((media || {}).children || {}).cms_entities_categories || {};
				mediaAttributes.tags = {};
				var ec, categoryDataAttributes, tagName;
				var cmsEntitiesCategories = mediaAttributes.tagsResources.data || [];
				for(ec in cmsEntitiesCategories){
					if((categoryDataAttributes = ((((cmsEntitiesCategories[ec] || {}).children || {}).cms_categoriesData || {}).data || {}).attributes)){
						tagName = categoryDataAttributes.value || '';
						if(((categoryDataAttributes.trls || {})[langCode] || {}).name){
							tagName = categoryDataAttributes.trls[langCode].name;
						}

						mediaAttributes.tags[utils.collectionSize(mediaAttributes.tags)] = utils.replace(categoryDataAttributes, {
							trls: undefined,
							name: tagName
						});
					}
				}

				// prepare highlighting for new media if necessary
				if ((((storage || {}).app || {}).service || {}).applicationType === 'cms'){
					mediaAttributes.isNew = (mediaAttributes || {}).createdAt && (new Date().getTime() - new Date(mediaAttributes.createdAt).getTime() < 7200000)
				}

				// simplify data
				utils.refReplace(media, mediaAttributes);

				// cleanup
				delete media.attributes;
				delete media.children;
				delete media.primaryKey;
			},

			/**
			 * this function is used to prepare the urls of one single set of mediaAttributes by reference.
			 *
			 * @param mediaAttributes			{} - media's attributes
			 * @param serviceMediaConfig		{} - serviceMediaConfig which should be used for preparation.
			 * @param ownServiceUrl				string - url of own service
			 */
			prepareUrls: function(mediaAttributes, serviceMediaConfig, ownServiceUrl){
				var target = mediaAttributes;
				var mediaID = mediaAttributes.mediaID || 0;
				var mediaGroup = mediaID % 50;
				var basePath, filename;

				if((mediaAttributes || {}).urlName) {
					filename = mediaAttributes.urlName;
				}
				else {
					if((mediaAttributes || {}).name) 	filename = mediaAttributes.name;
					else  								filename = 'file';
					mediaAttributes.urlName = filename = utils.media.getUrlReadyTitle(filename)
				}

				var mediaBaseUrl = serviceMediaConfig.url || '';
				if(mediaAttributes.isRestricted){
					mediaBaseUrl = ownServiceUrl || '';
				}

				// file delivered by container
				if(serviceMediaConfig.localMediaFolder || mediaAttributes.isRestricted){
					basePath = '/mediaFile/' + serviceMediaConfig.folder + '/' + mediaGroup + '/' + mediaID + '/';
					target.url 		= mediaBaseUrl + basePath + filename + '.' + mediaAttributes.extension;
					target.thumb 	= mediaBaseUrl + basePath + filename + '.symbol.' + mediaAttributes.extension;
				}
				// file delivered by nginx-proxy
				else {
					basePath = '/' + mediaGroup + '~' + mediaID + '/';
					target.url 		= (serviceMediaConfig.url || '') + basePath + filename + '.' + mediaAttributes.extension;
					target.thumb 	= (serviceMediaConfig.url || '') + basePath + filename + '.symbol.' + mediaAttributes.extension;
				}
			},

			/**
			 * remove unnecessary flags from assignmentMedia right before it will be written to the database
			 *
			 * @param media
			 * @returns mediaData needed for assignment (e.g., dataJSON of templateAtom)
			 */
			cleanupElementBeforeSet: function(media){
				media = media || {};
				return {
					mediaID: 	media.mediaID,
					data: 		media.data
				}
			},

			/**
			 * this function returns the symbol css-class used for the given extension
			 *
			 * @param 	extension		string - file extension
			 * @return 	string - symbol class
			 */
			getSymbolClass: function(extension){
				switch((extension || '').toLowerCase()){
					case 'gif':
					case 'jpg':
					case 'jpeg':
					case 'tiff':
					case 'png':
					case 'svg': return 'fi fi-file-image-o';
					case 'xls':
					case 'xlsx':
					case 'csv': return 'fi fi-file-excel-o';
					case 'txt': return 'fi fi-file-text-o';
					case 'pdf': return 'fi fi-file-pdf-o';
					default: return 'fi fi-file-o';
				}
			}
		},

		image: {

			/**
			 * prepare media according to the given resource data flag.
			 * NOTE: this function manipulates the media param by reference!
			 *
			 * @param media				{} - mediaData according to resourceTemplates like getCategorizedMedia, getCategorizedMediaFull
			 * 							e.g., { attributes: { mediaID: 13, ... }, children: { ... }}
			 * @param storage			{} - actual storage
			 * @param useOwnConfig		boolean - should the service own config be used?
			 */
			prepare: function(media, storage, useOwnConfig){
				// init
				if(media === undefined) 		media = {};
				if(useOwnConfig === undefined) 	useOwnConfig = true;

				// media config
				var activeServiceMediaConfig;
				if(useOwnConfig && !(activeServiceMediaConfig = ((((storage || {}).app || {}).service || {}).config || {}).media)){
					console.error('service media config not found');
					return false;
				}
				else if (!useOwnConfig && !(activeServiceMediaConfig = ((((storage || {}).app || {}).webService || {}).config || {}).media)){
					console.error('assigned service media config not found');
					return false;
				}

				// overwrite media url in developer mode to use fallback according to real used url if necessary
				if((storage.app.service || {}).developerMode && storage.requestUrl){
					activeServiceMediaConfig.url = storage.requestUrl;
				}

				var langCode = 'de-at';
				if(((storage.user || {}).data || {}).langCode){
					langCode = storage.user.data.langCode;
				}

				// define image name without extension if necessary
				var mediaAttributes = media.attributes || {};
				if(mediaAttributes.originalName) {
					var nameParts = String(mediaAttributes.originalName).split('.');
					if(nameParts.length > 1){
						// remove extension
						nameParts.pop();
					}
					// get image name without any dots (dots are not allowed to prevent nginx redirect errors)
					mediaAttributes.name = nameParts.join('.');
				} else {
					console.error('originalName not found in image');
				}

				// prepare media data flags
				var mediaLangAttributes = {};
				var assignedMediaData = {};
				var assignedMediaAttributes = {};
				var assignedMediaLangAttributes = {};
				var assignedMediaLangDataIndex;

				// prepare original media's lang data
				if((mediaAttributes.cms_mediaTrl || {})[langCode]){
					mediaLangAttributes = mediaAttributes.cms_mediaTrl[langCode];

					// override lang dependent fields
					if(mediaLangAttributes.name) 		mediaAttributes.name = mediaLangAttributes.name;
					if(mediaLangAttributes.title) 		mediaAttributes.title = mediaLangAttributes.title;
					if(mediaLangAttributes.alt) 		mediaAttributes.alt = mediaLangAttributes.alt;
					if(mediaLangAttributes.info) 		mediaAttributes.info = mediaLangAttributes.info;
					if(mediaLangAttributes.description) mediaAttributes.description = mediaLangAttributes.description;
				}

				// prepare assignment media data
				if(((media.children || {}).cms_assignedMedia || {}).data){
					assignedMediaData = media.children.cms_assignedMedia.data;
					assignedMediaAttributes = assignedMediaData.attributes || {};

					// override lang independent assignment fields
					if(assignedMediaAttributes.name) 		mediaAttributes.name = assignedMediaAttributes.name;

					// prepare assignment media lang dependent data
					for(assignedMediaLangDataIndex in ((assignedMediaData.relationships || {}).lang || {}).data || []){
						if((assignedMediaData.relationships.lang.data[assignedMediaLangDataIndex].attributes || {}).lang === langCode){
							assignedMediaLangAttributes = assignedMediaData.relationships.lang.data[assignedMediaLangDataIndex].attributes;

							// override lang dependent assignment fields
							if(assignedMediaLangAttributes.title) 	mediaAttributes.title = assignedMediaLangAttributes.title;
							if(assignedMediaLangAttributes.alt) 	mediaAttributes.alt = assignedMediaLangAttributes.alt;
						}
					}
				}

				utils.media.image.prepareUrls(mediaAttributes, undefined, activeServiceMediaConfig, mediaLangAttributes, assignedMediaAttributes, assignedMediaLangAttributes);

				// prepare tags
				mediaAttributes.tagsResources = ((media || {}).children || {}).cms_entities_categories || {};
				mediaAttributes.tags = {};
				var ec, categoryDataAttributes, tagName;
				var cmsEntitiesCategories = mediaAttributes.tagsResources.data || [];
				for(ec in cmsEntitiesCategories){
					if((categoryDataAttributes = ((((cmsEntitiesCategories[ec] || {}).children || {}).cms_categoriesData || {}).data || {}).attributes)){
						tagName = categoryDataAttributes.value || '';
						if(((categoryDataAttributes.trls || {})[langCode] || {}).name){
							tagName = categoryDataAttributes.trls[langCode].name;
						}

						mediaAttributes.tags[utils.collectionSize(mediaAttributes.tags)] = utils.replace(categoryDataAttributes, {
							trls: undefined,
							name: tagName
						});
					}
				}

				// prepare rendered
				var mr, mediaRendered = (((media || {}).children || {}).cms_mediaRendered || {}).data || [];
				mediaAttributes.rendered = [];
				for(mr in mediaRendered){
					if((mediaRendered[mr] || {}).attributes){
						utils.media.image.prepareUrls(mediaAttributes, mediaRendered[mr].attributes, activeServiceMediaConfig, mediaLangAttributes, assignedMediaAttributes, assignedMediaLangAttributes)
						mediaAttributes.rendered.push(mediaRendered[mr].attributes);
					}
				}

				// prepare highlighting for new media if necessary
				if ((((storage || {}).app || {}).service || {}).applicationType === 'cms'){
					mediaAttributes.isNew = (mediaAttributes || {}).createdAt && (new Date().getTime() - new Date(mediaAttributes.createdAt).getTime() < 7200000)
				}

				// simplify data
				utils.refReplace(media, mediaAttributes);

				// downwards compatibility stuff
				media.data = ((media.children || {}).cms_assignedMedia || {}).data || {};

				// cleanup
				delete media.attributes;
				delete media.children;
				delete media.primaryKey;
			},

			/**
			 * this function is used to prepare the urls of one single set of mediaAttributes (or renderedMediaAttributes) by reference.
			 *
			 * @param mediaAttributes			{} - media's attributes
			 * @param renderedMediaAttributes	{} - rendered media's attributes (may be undefined)
			 * @param serviceMediaConfig		{} - serviceMediaConfig which should be used for preparation.
			 */
			prepareUrls: function(mediaAttributes, renderedMediaAttributes, serviceMediaConfig){
				var target;
				var mediaID = mediaAttributes.mediaID || 0;
				var mediaRenderedID;
				var mediaGroup = mediaID % 50;
				var basePath, filename;

				if(renderedMediaAttributes){
					target = renderedMediaAttributes;
					mediaRenderedID = renderedMediaAttributes.mediaRenderedID;
				} else {
					target = mediaAttributes;
				}

				if((mediaAttributes || {}).urlName) {
					filename = mediaAttributes.urlName;
				}
				else {
					if((mediaAttributes || {}).name) 	filename = mediaAttributes.name;
					else  								filename = 'image';
					mediaAttributes.urlName = filename = utils.media.getUrlReadyTitle(filename)
				}

				// demo case
				if(serviceMediaConfig.localMediaFolder){
					basePath = '/mediaFallback/' + serviceMediaConfig.folder + '/' + mediaGroup + '/' + mediaID + '/' + (mediaRenderedID || '~') + '/';
					target.url 		= (serviceMediaConfig.url || '') + basePath + 'original/' + mediaAttributes.extension + '/' + filename + '.' + mediaAttributes.extension;
					target.thumb 	= (serviceMediaConfig.url || '') + basePath + 'thumb/' + mediaAttributes.extension + '/' + filename + '.' + mediaAttributes.extension;
				}
				else {
					if(mediaRenderedID) basePath = '/' + mediaGroup + '~' + mediaID + '~' + mediaRenderedID + '/';
					else  				basePath = '/' + mediaGroup + '~' + mediaID + '/';
					target.url 		= (serviceMediaConfig.url || '') + basePath + filename + '.' + mediaAttributes.extension;
					target.thumb 	= (serviceMediaConfig.url || '') + basePath + filename + '.thumb.' + mediaAttributes.extension;
				}
			},


			/**
			 * this function is used to identify the right mediaData for each image given in images and return simplified data.
			 * the function respects the users' breakPoint, the users' device, the configuration of the templateAtom which is in charge and
			 * if to use the layout for assigned or own media according to the actual serviceConfig.
			 *
			 * @param   images                  {} - list of images which should be minified to the simplified data.
			 *                                  NOTE: this can be one single image too.
			 * @param   storage                 {} - actual storage
			 * @param   imageConfig             {} - config object located in templateAtom of the given images (optional)
			 *                                  NOTE:   it is recommended to provide this config to be able to perform
			 *                                          best possible elimination checks.
			 * @param   useAssignedMediaConfig  boolean - should the media configuration for the assigned or the own service be used. (default: false)
			 * @param   preloadDetectedUrls     boolean - if this flag is set to true this function tries to load the images before returing. (default: false)
			 * @param   onImageLoadedCallback   function - if this parameter is a function it will be called without parameters after an image preloading has been done.
			 * @param   containerDimensions     {} - dimensions of the container which wants to use this image
			 *                                  NOTE: this can be the components DOM-Representation or the actual window-dimensions.
			 *                                  NOTE: this flag is only set when this is a client side call.
			 * @param   codeNames				String or Array of Strings - return only rendered images according to the given codeNames.
			 * @returns {
			 *              imageList: [
			 *                  {
			 *                  	mediaID: <mediaID>,
			 *                  	index: <assignment index>,
			 *                      url: <complete url to load image - may be empty string>,
			 *                      thumb: <complete url to load thumb - may be empty string>,
			 *
			 *                  	width: <width - width of original image [px]>,
			 *                  	height: <height - height of original image [px]>,
			 *                  	name: <original filename without extension>,
			 *                  	sizeInBytes: <sizeInBytes>,
			 *                  	extension: <extension without dot>,
			 *                  	isRestricted: <isRestricted>,
			 *                  	exifData: <exifData - may be null>,
			 *                  	createdAt: <createdAt - iso timestamp>,
			 *                  	updatedAt: <updatedAt - iso timestamp>,
			 *
			 *                  	title: <title - may be null - lang dependent>,
			 *                  	alt: <alt - may be null - lang dependent>,
			 *                  	name: <name - may be null - lang dependent>,
			 *                  	info: <info - may be null - lang dependent>,
			 *                  	description: <description - may be null - lang dependent>,
			 *                  	copyright: <copyright - may be null - lang independent>,
			 *
			 *                  	tags: {
			 *                  	 	<tagIndex>: {		// categoryData attributes of tag
			 *                  			sort: <sort integer>,
			 *                  			color: <color - may be null>,
			 *                  			value: <value - may be null>,
			 *                  			config: <config - may be null>,
			 *                  			priority: <priority - may be null>,
			 *                  			categoryID: <categoryID integer>,
			 *                  			categoryDataID: <categoryDataID integer>,
			 *                  			parentCategoryDataID: <parentCategoryDataID - may be null>,
			 *                  			defaultSelected: <defaultSelected - may be null>,
			 *                  			name: <name - may be null - lang dependent>
			 *                  	 	}
			 *                  	},
			 *                  	// rendered may be a codeName separated object of rendered images if there are codenames present (either by config or by parameter)
			 *                  	rendered: {
			 *                  		mediaID: <mediaID>,
			 *                  		mediaRenderedID: <mediaRenderedID>,
			 *                  		url: <url>,
			 *                  		thumb: <thumb>,
			 *                  		title: <title>,
			 *                  		alt: <alt>,
			 *                  		width: <width>,
			 *                  		height: <height>,
			 *                  		class: <class>
			 *                  	}
			 *                  },
			 *                  ...
			 *              ],
			 *              nrOfPreloadingImages: <number of preloading images - use onImageLoadedCallback to handle image dependent code>
			 *           }
			 */
			detectRendered: function(images, storage, imageConfig, useAssignedMediaConfig, preloadDetectedUrls, onImageLoadedCallback, containerDimensions, codeNames){
				// init
				var imageList = [];
				if(images && images.mediaID){
					return utils.media.image.detectRendered([images], storage, imageConfig, useAssignedMediaConfig, preloadDetectedUrls, onImageLoadedCallback, containerDimensions, codeNames);
				}
				if(!images || utils.collectionSize(images) === 0){
					return {
						imageList:              imageList,
						nrOfPreloadingImages:   0
					};
				}

				useAssignedMediaConfig = !!useAssignedMediaConfig;
				preloadDetectedUrls = !!preloadDetectedUrls;
				var activeMediaConfig;
				var device = 'desktop';
				var breakPoint = 'm';
				var breakPointMaxWidth;
				var activeBreakPoints;
				var clazz;
				var forceUrl;

				// check preconditions
				if(!storage){
					console.error('missing storage');
					return {
						imageList:              imageList,
						nrOfPreloadingImages:   0
					};
				}
				else if(!(((storage.app || {}).service || {}).config || {}).media){
					console.error('missing serviceMediaConfig');
					return {
						imageList:              imageList,
						nrOfPreloadingImages:   0
					};
				}
				else if(!(((storage.app || {}).webService || {}).config || {}).media){
					console.error('missing webServiceMediaConfig');
					return {
						imageList:              imageList,
						nrOfPreloadingImages:   0
					};
				}

				// set active media config
				if(useAssignedMediaConfig){
					activeMediaConfig = storage.app.webService.config.media;
				}
				else {
					activeMediaConfig = storage.app.service.config.media;
				}

				// set users' device and breakPoint if possible
				if(((storage.user || {}).data || {}).environment){
					// set default container dimensions if possible
					if(!containerDimensions && storage.user.data.environment.dimensions && storage.user.data.environment.dimensions.window){
						containerDimensions = storage.user.data.environment.dimensions.window;
					}

					if(storage.user.data.environment.device && storage.user.data.environment.device.type){
						device = storage.user.data.environment.device.type;
					}
					if(storage.user.data.environment.breakPoint){
						breakPoint = storage.user.data.environment.breakPoint;
					}
				}

				// check if image preloading is granted by serviceConfig
				if(activeMediaConfig.preloadImagesGranted === false){
					preloadDetectedUrls = false;
				}

				// set active list of breakPoints
				if(activeMediaConfig.layout){
					if(!device){
						var firstActiveLayoutKey = Object.keys(activeMediaConfig.layout).pop();
						if(typeof(activeMediaConfig.layout[firstActiveLayoutKey]) === 'number' && firstActiveLayoutKey.length() <= 2){
							activeBreakPoints = activeMediaConfig.layout;
						}
					}
					else if(activeMediaConfig.layout[device]){
						activeBreakPoints = activeMediaConfig.layout[device];
					}
				}

				// prepare linear list of renderConfigs
				var extractedLinearListOfRenderConfigs = utils.media.image.extractLinearListOfRenderConfigs(((imageConfig || {}).config || {}).render, activeMediaConfig, device, activeBreakPoints);
				var renderConfigList 	= extractedLinearListOfRenderConfigs.renderConfigList;
				var availableCodeNames 	= extractedLinearListOfRenderConfigs.availableCodeNames;

				// prepare codeNames
				if(availableCodeNames.length === 0){
					availableCodeNames = [DEFAULT_RENDERED_IMAGE_CODENAME];
				}
				if(!codeNames) {
					codeNames = availableCodeNames;
				} else if(typeof(codeNames) === 'string'){
					codeNames = [codeNames];
				}
				if (!utils.isArray(codeNames)){
					console.error('codeNames of rendered images are not allowed to be anything else but an array');
				}
				var codeNameIndex;
				for(codeNameIndex in codeNames){
					if(utils.indexOf(availableCodeNames, codeNames[codeNameIndex]) < 0){
						codeNames.splice(codeNameIndex, 1);
					}
				}
				if(codeNames.length === 0){
					console.error('missing codeNames');
					return {
						imageList:              imageList,
						nrOfPreloadingImages:   0
					};
				}

				// prepare loading options if necessary
				if(storage.isServer && imageConfig && imageConfig.loadingOptions && (!storage.user.data.serverKnownEnvironment || !storage.user.data.serverKnownEnvironment.skipLoadingOptions)){
					if (imageConfig.loadingOptions.url)         forceUrl    = imageConfig.loadingOptions.url;
					if (imageConfig.loadingOptions['class'])    clazz       = imageConfig.loadingOptions['class'];
				}

				if(!forceUrl){

					// set breakPointMaxWidth if possible
					if(activeBreakPoints && breakPoint && activeBreakPoints[breakPoint]){
						breakPointMaxWidth = activeBreakPoints[breakPoint];
					}

					// check if image preloading is granted by imageConfig
					if(imageConfig && imageConfig.preloadImagesGranted === false){
						preloadDetectedUrls = false;
					}
				}

				// sanitize on image loaded callback if necessary
				if(storage.isClient && preloadDetectedUrls && typeof(onImageLoadedCallback) !== 'function'){
					onImageLoadedCallback = function(){};
				}

				// set function essentials
				var nrOfPreloadingImages    = 0;
				var defaultImageData        = {
					mediaID: 0,
					mediaRenderedID: 0,
					url: '',
					thumb: '',
					title: '',
					alt: '',
					name: '',
					width: 0,
					height: 0,
					class: clazz || ''
				};

				// prepare images
				var baseCandidateLists = {
					deviceAndBreakPoint: [],
					device: [],
					breakPoint: [],
					fallback: []
				};
				var c, availableCandidateLists = {};
				for(c in codeNames){
					availableCandidateLists[codeNames[c]] = utils.simpleCopy(baseCandidateLists);
				}
				var previewModeInEffect = (((storage.user || {}).data || {}).serviceCollectionOptions || {}).viewMode === 'preview';

				// estimate candidates
				utils.forEach(images, function(image, imageIndex){
					if(!image.missingMainDBEntry && (!image.pause || previewModeInEffect)){
						var imageListEntry = {};

						// prepare images' renderDetectionMemory
						image.renderDetectionMemory = {
							candidateList: 		{},
							candidateListType: 	{},
							candidateLists: 	utils.simpleCopy(availableCandidateLists),
							candidateData: 		utils.simpleCopy(defaultImageData)
						}

						// prepare image data
						image.renderDetectionMemory.candidateData.mediaID = image.mediaID;
						if(image.title) image.renderDetectionMemory.candidateData.title = image.title;
						if(image.alt) 	image.renderDetectionMemory.candidateData.alt 	= image.alt;
						if(image.name) 	image.renderDetectionMemory.candidateData.name 	= image.name;

						if(forceUrl){
							if(!codeNames || (codeNames.length === 1 && codeNames[0] === DEFAULT_RENDERED_IMAGE_CODENAME)){
								imageList.push(utils.replace(image.renderDetectionMemory.candidateData, {
									url:    forceUrl,
									thumb:  ''
								}));
							} else {
								imageListEntry = {};
								for(c in codeNames){
									imageListEntry[codeNames[c]] = utils.replace(image.renderDetectionMemory.candidateData, {
										url:   	 	forceUrl,
										thumb:  	'',
										codeName: 	codeNames[c]
									});
								}
								imageList.push(imageListEntry);
							}
						}
						else {
							// use rendered image if possible
							if(image.rendered){
								utils.forEach(image.rendered, function(renderedImage){
									utils.forEach(image.renderDetectionMemory.candidateLists, function(candiateLists, codeName){
										if(
											codeName === DEFAULT_RENDERED_IMAGE_CODENAME
											||
											(
												!renderedImage.codeName &&
												utils.media.image.renderedMatchesOneConfig(renderedImage, renderConfigList, codeName, breakPoint, device)
											)
											||
											renderedImage.codeName === codeName
										){
											if(renderedImage.device === device){
												if(renderedImage.breakPoint === breakPoint){
													image.renderDetectionMemory.candidateLists[codeName].deviceAndBreakPoint.push(renderedImage);
												}
												else {
													image.renderDetectionMemory.candidateLists[codeName].device.push(renderedImage);
												}
											}
											else if(renderedImage.breakPoint === breakPoint){
												image.renderDetectionMemory.candidateLists[codeName].breakPoint.push(renderedImage);
											}
											else {
												image.renderDetectionMemory.candidateLists[codeName].fallback.push(renderedImage);
											}
										}
									});
								});
							}

							// choose candidateList
							utils.forEach(image.renderDetectionMemory.candidateLists, function(candidateLists, codeName){
								utils.forEach(candidateLists, function(candidateList, candidateType){
									if(candidateList.length > 0){
										image.renderDetectionMemory.candidateList[codeName]     = candidateList;
										image.renderDetectionMemory.candidateListType[codeName] = candidateType;
										return false;
									}
								});
							});

							// list of chosen image candidates per codeName
							imageListEntry = {};
							utils.forEach(codeNames, function(codeName){
								var candidateList = image.renderDetectionMemory.candidateList[codeName] || [];
								var realCodeName;
								var loadImage;
								if(codeName !== DEFAULT_RENDERED_IMAGE_CODENAME) realCodeName = codeName;

								// take main image
								if(candidateList.length <= 0){
									imageListEntry[codeName] = utils.replace(image.renderDetectionMemory.candidateData, {
										url:    	image.url,
										thumb:  	image.thumb,
										codeName: 	realCodeName
									});
								}
								// take single candidate
								else if(candidateList.length === 1){
									imageListEntry[codeName] = utils.replace(image.renderDetectionMemory.candidateData, {
										url:    			candidateList[0].url,
										thumb:  			candidateList[0].thumb,
										width:  			candidateList[0].width,
										height: 			candidateList[0].height,
										codeName: 			realCodeName,
										mediaRenderedID: 	candidateList[0].mediaRenderedID
									});
								}
								// choose from multiple available candidates
								else {
									var candidate;
									var candidateIdentified = false;
									var bestCandidates = Object.keys(candidateList);
									var distanceList;
									var distance;
									var minDistanceGreaterThanZero;
									var maxDistanceLowerThanZero;
									var c;
									var check;
									var checks = [];
									var usedDevice;
									var usedBreakPoint;

									// check imageConfig conditions
									if(imageConfig){
										if(imageConfig.maxWidth){
											// check if candidates meet size conditions according to imageConfig
											if(typeof(imageConfig.maxWidth) === 'number'){
												checks.push('imageConfig.maxWidth.simple');
											}
											else if(typeof(imageConfig.maxWidth) === 'object' && utils.collectionSize(imageConfig.maxWidth) > 0){
												var firstMaxWidthKey = Object.keys(imageConfig.maxWidth).pop();

												if(typeof(imageConfig.maxWidth[firstMaxWidthKey]) === 'number'){
													// check if candidates meet breakPoint-size conditions according to imageConfig
													if(firstMaxWidthKey.length() <= 2){
														checks.push('imageConfig.maxWidth.breakPoint');
													}
													// check if candidates meet device-size conditions according to imageConfig
													else {
														checks.push('imageConfig.maxWidth.device');
													}
												}
												// check if candidates meet device-breakPoint-size conditions according to imageConfig
												else {
													checks.push('imageConfig.maxWidth.deviceAndBreakPoint');
												}
											}
										}
									}

									// no full match found => eliminate elements which have not lowest breakPoint-distance
									if(activeBreakPoints && breakPointMaxWidth && (image.renderDetectionMemory.candidateListType[codeName] === 'device' || image.renderDetectionMemory.candidateListType[codeName] === 'fallback')) {
										checks.push('layout.breakPointDistance');
									}

									// check container dimensions
									if(containerDimensions){
										checks.push('container.dimensions');
									}

									// check container dimensions
									checks.push('fallback.biggestFirst');

									// perform all listed checks
									for(var checkIndex in checks){
										// init check
										check = checks[checkIndex];
										distanceList = {};
										minDistanceGreaterThanZero = Number.MAX_SAFE_INTEGER;
										maxDistanceLowerThanZero = Number.MIN_SAFE_INTEGER;

										// check all candidates left
										for(c in bestCandidates) {
											candidate = candidateList[bestCandidates[c]];

											switch(check){
												case 'imageConfig.maxWidth.simple':
													distance = imageConfig.maxWidth - candidate.width;
													break;

												case 'imageConfig.maxWidth.breakPoint':
													// check against imageConfig which is assigned to users' breakpoint
													if(breakPoint && imageConfig[breakPoint]) {
														distance = imageConfig[breakPoint] - candidate.width;
													}
													// check against imageConfig which is assigned to images' breakpoint
													else if(candidate.breakPoint && imageConfig[candidate.breakPoint]) {
														distance = imageConfig[candidate.breakPoint] - candidate.width;
													}
													else {
														continue;
													}
													break;

												case 'imageConfig.maxWidth.device':
													// check against imageConfig which is assigned to users' device
													if(device && imageConfig[device]) {
														distance = imageConfig[device] - candidate.width;
													}
													// check against imageConfig which is assigned to images' device
													else if(candidate.device && imageConfig[candidate.device]) {
														distance = imageConfig[candidate.device] - candidate.width;
													}
													else {
														continue;
													}
													break;

												case 'imageConfig.maxWidth.deviceAndBreakPoint':
													usedDevice = undefined;
													usedBreakPoint = undefined;

													if(device && imageConfig[device])                           usedDevice = device;
													else if(candidate.device && imageConfig[candidate.device])  usedDevice = candidate.device;

													if(usedDevice){
														if(breakPoint && imageConfig[usedDevice][breakPoint])                           usedBreakPoint = breakPoint;
														else if(candidate.breakPoint && imageConfig[usedDevice][candidate.breakPoint])  usedBreakPoint = candidate.breakPoint;

														if(usedBreakPoint){
															distance = imageConfig[usedDevice][usedBreakPoint] - candidate.width;
														}
														else {
															continue;
														}
													}
													else {
														continue;
													}
													break;


												case 'layout.breakPointDistance':
													if(candidate.breakPoint && activeBreakPoints[candidate.breakPoint]) {
														distance = breakPointMaxWidth - activeBreakPoints[candidate.breakPoint];
													}
													else {
														continue;
													}
													break;

												case 'container.dimensions':
													distance = containerDimensions.width - candidate.width;
													break;

												case 'fallback.biggestFirst':
													distance = candidate.width - Number.MAX_SAFE_INTEGER;
													break;
											}

											if(distanceList[distance] === undefined){
												distanceList[distance] = [];
											}
											distanceList[distance].push(c);
											if(distance > 0){
												minDistanceGreaterThanZero = Math.min(minDistanceGreaterThanZero, distance);
											}
											else if(distance < 0) {
												maxDistanceLowerThanZero = Math.max(maxDistanceLowerThanZero, distance);
											}
										}

										// take candidates matching the wanted maxWidth
										if(distanceList[0]){
											bestCandidates = distanceList[0];
										}
										// take candidates which are slightly greater than the wanted maxWidth
										else if(maxDistanceLowerThanZero > Number.MIN_SAFE_INTEGER){
											bestCandidates = distanceList[maxDistanceLowerThanZero];
										}
										// take candidates which are slightly smaller than the wanted maxWidth
										else if(minDistanceGreaterThanZero < Number.MAX_SAFE_INTEGER){
											bestCandidates = distanceList[minDistanceGreaterThanZero];
										}

										if(bestCandidates.length <= 0){
											console.error('error during check[' + check + '] in multiple-candidates-problem');
										}
										else if(bestCandidates.length == 1){
											candidateIdentified = true;
											imageListEntry[codeName] = utils.replace(image.renderDetectionMemory.candidateData, {
												url:    			candidateList[bestCandidates[0]].url,
												thumb:  			candidateList[bestCandidates[0]].thumb,
												width:  			candidateList[bestCandidates[0]].width,
												height: 			candidateList[bestCandidates[0]].height,
												codeName: 			realCodeName,
												mediaRenderedID: 	candidateList[bestCandidates[0]].mediaRenderedID
											});
											break;
										}
									}

									// error handling
									if(!candidateIdentified){
										console.error('imageList not complete according to multiple-candidates-problem');

										// choose first one as global fallback
										// candidateIdentified = true;
										imageListEntry[codeName] = utils.replace(image.renderDetectionMemory.candidateData, {
											url:    			candidateList[bestCandidates[0]].url,
											thumb:  			candidateList[bestCandidates[0]].thumb,
											width:  			candidateList[bestCandidates[0]].width,
											height: 			candidateList[bestCandidates[0]].height,
											codeName: 			realCodeName,
											mediaRenderedID: 	candidateList[bestCandidates[0]].mediaRenderedID
										});
									}
								}

								// load image if necessary
								if(storage.isClient && preloadDetectedUrls && imageListEntry[codeName] && !imageListEntry[codeName].preloaded){
									nrOfPreloadingImages++;
									imageListEntry[codeName].preloaded = true;
									loadImage = new Image();
									loadImage.onload = onImageLoadedCallback;
									loadImage.onerror = onImageLoadedCallback;
									loadImage.src = imageListEntry[codeName].url;
								}
							});

							if(utils.collectionSize(imageListEntry) > 0){
								var chosenImageListEntry;
								if(codeNames.length === 1 && codeNames[0] === DEFAULT_RENDERED_IMAGE_CODENAME){
									chosenImageListEntry = imageListEntry[DEFAULT_RENDERED_IMAGE_CODENAME];
								} else {
									chosenImageListEntry = imageListEntry;
								}

								// utils.replace is not used for deletion only.
								// additionally it is used to prevent referential changes within the modelField.
								imageList.push(utils.replace(image, {
									renderDetectionMemory: 	undefined,
									tagsResources: 			undefined,
									cms_mediaTrl: 			undefined,
									data: 					undefined,

									rendered: 				chosenImageListEntry
								}));
							}
						}
					}
				});

				return {
					imageList:              imageList,
					nrOfPreloadingImages:   nrOfPreloadingImages
				};
			},

			/**
			 * remove unnecessary flags from assignmentMedia right before it will be written to the database
			 *
			 * @param media
			 * @returns mediaData needed for assignment (e.g., dataJSON of templateAtom)
			 */
			cleanupElementBeforeSet: function(media){
				media = media || {};
				var renderedImageIndex, rendered = [];
				for(renderedImageIndex in media.rendered || []){
					if(media.rendered[renderedImageIndex].mediaRenderedID){
						rendered.push({
							mediaRenderedID: media.rendered[renderedImageIndex].mediaRenderedID
						});
					}
				}
				var result = {
					mediaID: 	media.mediaID,
					data: 		media.data,
					rendered: 	rendered
				}
				if(media.pause === true){
					result.pause = true;
				}
				return result;
			},

			/**
			 * this function returns the maximum dimensions needed for a given image-config parameter.
			 *
			 * @param   imageConfig     		{} - actual image config used within the template-atom of an image
			 * @param   activeMediaConfig       {} - activeMediaConfig defined by service
			 * @return  {
			 *              width: number,
			 *              height: number
			 *          }
			 */
			detectMaxDimensions: function(imageConfig, activeMediaConfig){
				if(!imageConfig || !imageConfig.render) return { width: 0, height: 0 };

				var act;
				var max = {
					width: 0,
					height: 0
				};

				var activeBreakPoints;
				// set active list of breakPoints if possible
				if((activeMediaConfig || {}).layout){
					var firstActiveLayoutKey = Object.keys(activeMediaConfig.layout).pop();
					if(typeof(activeMediaConfig.layout[firstActiveLayoutKey]) === 'number' && firstActiveLayoutKey.length() <= 2){
						activeBreakPoints = activeMediaConfig.layout;
					}
				}

				// prepare linear list of renderConfigs
				var extractedLinearListOfRenderConfigs 	= utils.media.image.extractLinearListOfRenderConfigs((imageConfig || {}).render, activeMediaConfig, undefined, activeBreakPoints);
				var renderConfigList 					= (extractedLinearListOfRenderConfigs || {}).renderConfigList;

				// use renderConfigList each time possible.
				// NOTE: the other cases are merely fallbacks than really necessary
				if ((renderConfigList || []).length > 0){
					for(var rc in renderConfigList){
						act = utils.media.image.detectMaxConfigDimensions(renderConfigList[rc]);
						max.width = Math.max(act.width, max.width);
						max.height = Math.max(act.height, max.height);
					}
				}
				else if(imageConfig.devices){
					if(imageConfig.breakPoints){
						for(var device in imageConfig.render){
							for(var breakPoint in imageConfig.render[device]){
								act = utils.media.image.detectMaxConfigDimensions(imageConfig.render[device][breakPoint]);
								max.width = Math.max(act.width, max.width);
								max.height = Math.max(act.height, max.height);
							}
						}
					}
					else {
						for(var device in imageConfig.render){
							act = utils.media.image.detectMaxConfigDimensions(imageConfig.render[device]);
							max.width = Math.max(act.width, max.width);
							max.height = Math.max(act.height, max.height);
						}
					}
				}
				else if(imageConfig.breakPoints) {
					for(var breakPoint in imageConfig.render[device]){
						act = utils.media.image.detectMaxConfigDimensions(imageConfig.render[breakPoint]);
						max.width = Math.max(act.width, max.width);
						max.height = Math.max(act.height, max.height);
					}
				}
				else {
					act = utils.media.image.detectMaxConfigDimensions(imageConfig.render);
					max.width = Math.max(act.width, max.width);
					max.height = Math.max(act.height, max.height);
				}

				return max;
			},

			/**
			 * this function returns the maximum width and height needed by a given renderConfig.
			 *
			 * @param   renderConfig        {} - renderConfig of a media-render-call
			 * @return  {
			 *              width: number,
			 *              height: number
			 *          }
			 */
			detectMaxConfigDimensions: function(renderConfig){
				if(renderConfig.type === 'dynamic'){
					return {
						width:  renderConfig.maxWidth || renderConfig.minWidth || 0,
						height: renderConfig.maxHeight || renderConfig.minHeight || 0
					}
				}

				return {
					width:  renderConfig.width || 0,
					height: renderConfig.height || 0
				}
			},

			/**
			 * this function returns a list of renderImageConfigs which are needed to render an image according to the given imageConfig.
			 * NOTE: in case of incomplete parameters or definitions the function will return an empty list.
			 *
			 * @param   image                   {} - mediaImage
			 * @param   imageConfig             {} - mediaImageConfig
			 * @param   activeMediaConfig       {} - activeMediaConfig defined by service
			 * @param   activeEnvironment       {} - activeEnvironment
			 * @return  [{<renderImageConfig>}, ...]
			 */
			prepareRenderConfigs: function(image, imageConfig, activeMediaConfig, activeEnvironment){
				var renderConfigs = [];
				if(image && imageConfig && imageConfig.render && !utils.isEmpty(imageConfig.render)){
					// prepare helper data
					var device, activeBreakPoints = [];
					if(((activeEnvironment || {}).device || {}).type) 				device = activeEnvironment.device.type;
					if(device && ((activeMediaConfig || {}).layout || {})[device]) 	activeBreakPoints = activeMediaConfig.layout[device];

					// prepare renderConfigs
					renderConfigs = utils.media.image.extractLinearListOfRenderConfigs(imageConfig.render, activeMediaConfig, device, activeBreakPoints).renderConfigList || [];

					// set mediaID in configs
					var rc;
					for(rc in renderConfigs){
						renderConfigs[rc].mediaID = image.mediaID;
					}
				}

				return renderConfigs;
			},

			/**
			 * this function returns a linear list of all renderConfigs found within the given renderConfig param and
			 * a list of available codeNames used within them.
			 *
			 * @param renderConfig				{} - renderConfig defined by templateAtom
			 * @param activeMediaConfig			{} - active media config defined by service
			 * @param device					string - optional - actual device code
			 * @param activeBreakPoints			[] - optional - list of active breakPoints (e.g., within the given device) defined by service
			 * @param recursionStorage			{} - used for function internal logic.
			 * 									NOTE: never ever define this param from outside!
			 * @returns {{
			 * 				availableCodeNames: [],
			 * 				renderConfigList: 	[
			 * 				 	{
			 * 				 	  <oneSingleRenderConfigParams>,
			 * 				 	  device: <device>,
			 * 				 	  breakPoint: <breakPoint>,
			 * 				 	  codeName: <codeName>
			 * 				 	}, ...
			 * 				]
			 * 			}}
			 */
			extractLinearListOfRenderConfigs: function(renderConfig, activeMediaConfig, device, activeBreakPoints, recursionStorage){
				// init
				if(!recursionStorage) 						recursionStorage = {};
				if(!recursionStorage.state) 				recursionStorage.state = {};
				if(!recursionStorage.configList) 			recursionStorage.configList = [];
				if(!recursionStorage.availableCodeNames) 	recursionStorage.availableCodeNames = [];
				if(!recursionStorage.supportedDevices) {
					recursionStorage.supportedDevices = [];
					if((activeMediaConfig || {}).layout){
						recursionStorage.supportedDevices = Object.keys(activeMediaConfig.layout);
					}
				}
				if(!recursionStorage.supportedBreakPoints) {
					recursionStorage.supportedBreakPoints = [];
					if(activeBreakPoints){
						recursionStorage.supportedBreakPoints = Object.keys(activeBreakPoints);
					}
				}

				if(renderConfig && utils.collectionSize(renderConfig) > 0){

					// single config
					if(
						renderConfig.type ||
						renderConfig.width ||
						renderConfig.height ||
						renderConfig.minWidth ||
						renderConfig.maxWidth
					){
						renderConfig.device 	= device;
						renderConfig.breakPoint = recursionStorage.state.breakPoint;
						renderConfig.codeName 	= recursionStorage.state.codeName;
						recursionStorage.configList.push(utils.simpleCopy(renderConfig));
					}
					// multiple configs
					else {
						var configID;
						for(configID in renderConfig){
							// is device
							if(utils.indexOf(recursionStorage.supportedDevices, configID) > -1){
								recursionStorage.state.device = configID;
								utils.media.image.extractLinearListOfRenderConfigs(renderConfig[configID], activeMediaConfig, device, activeBreakPoints, recursionStorage);
								delete recursionStorage.state.device;
							}
							// is breakpoint
							else if(utils.indexOf(recursionStorage.supportedBreakPoints, configID) > -1){
								recursionStorage.state.breakPoint = configID;
								utils.media.image.extractLinearListOfRenderConfigs(renderConfig[configID], activeMediaConfig, device, activeBreakPoints, recursionStorage);
								delete recursionStorage.state.breakPoint;
							}
							// is codename
							else {
								if(utils.indexOf(recursionStorage.availableCodeNames, configID) < 0) recursionStorage.availableCodeNames.push(configID);
								recursionStorage.state.codeName = configID;
								utils.media.image.extractLinearListOfRenderConfigs(renderConfig[configID], activeMediaConfig, device, activeBreakPoints, recursionStorage);
								delete recursionStorage.state.codeName;
							}
						}
					}
				}

				return {
					availableCodeNames: recursionStorage.availableCodeNames,
					renderConfigList: recursionStorage.configList
				};
			},

			/**
			 * this function returns true if the given renderedImage matches at least one single renderConfig defined by
			 * the renderConfigList param.
			 *
			 * @param renderedImage			{} - renderedImage to check for a match
			 * @param renderConfigList		[] - linear renderConfigList
			 * 								NOTE: renderConfigList has to be linear (@see utils.media.image.extractLinearListOfRenderConfigs method)
			 * @param codeName				string - optional - actual codeName you are looking for
			 * @param breakPoint			string - optional - actual breakPoint you are looking for
			 * @param device				string - optional - actual device your are looking for
			 * @returns {boolean} matchFound?
			 */
			renderedMatchesOneConfig: function(renderedImage, renderConfigList, codeName, breakPoint, device){
				if(!renderedImage) return false;
				if(!renderConfigList || utils.collectionSize(renderConfigList) < 1) return false;

				var rc, renderConfig;
				for(rc in renderConfigList){
					renderConfig = renderConfigList[rc];

					if(
						(!renderConfig.codeName		|| codeName === renderConfig.codeName) &&
						(!renderConfig.device 		|| device === renderConfig.device) &&
						(!renderConfig.breakPoint 	|| breakPoint === renderConfig.breakPoint) &&
						// image dimension checks
						(
							// dynamic
							(
								renderConfig.type === 'dynamic' &&
								(renderConfig.minWidth <= 0 || renderedImage.width >= renderConfig.minWidth) &&
								(renderConfig.maxWidth <= 0 || renderedImage.width <= renderConfig.maxWidth)
							)
							||
							// fixed
							(
								(!renderConfig.type || renderConfig.type === 'fixed') &&
								(!renderConfig.width || renderConfig.width <= 0 || renderedImage.width === renderConfig.width) &&
								(!renderConfig.height || renderConfig.height <= 0 || renderedImage.height === renderConfig.height)
							)
						)
					){
						return true;
					}
				}

				return false;
			}
		}
	},

	routes: {
		prepare: function(route, storage){
			var resourceRoute = route.resource || {};

			// set core data
			route.url 		= resourceRoute.path;
			route.visible	= resourceRoute.visible;
			route.langCode 	= resourceRoute.langCode;
			route.tags 		= resourceRoute.tags || {};

			// prepare tags
			var usedLangCode = route.langCode || storage.user.data.langCode;
			var categoryID, categoryDataID;
			var category, categoryData;
			for(categoryID in route.tags){
				category = route.tags[categoryID];
				if((category.trls || {})[usedLangCode]){
					category.langCode = usedLangCode;
					utils.refReplace(category, category.trls[usedLangCode]);
				}
				delete category.trls;

				for(categoryDataID in category.tags){
					categoryData = category.tags[categoryDataID];
					if((categoryData.trls || {})[usedLangCode]){
						categoryData.langCode = usedLangCode;
						utils.refReplace(categoryData, categoryData.trls[usedLangCode]);
					}
					delete categoryData.trls;
				}
			}

			// cleanup
			delete route.resource;
		},
	},

	fields: {

		/**
		 * prepare resource pickers data according to given resourceData param.
		 *
		 * @param modelField					{} - reference to right modelField
		 * @param resourceTargetModelField 		{} - reference to modelField where the data should be stored
		 * 										NOTE: may differ according to isPicked flag.
		 * @param resourceData					{} - resourceData given by resourceAction (or serverside preloaded resourceData)
		 * @param storage						{} - actual storage
		 * @param resourceLoader				{} - reference on resourceLoader used for picking
		 */
		prepareResourcePicker: function(modelField, resourceTargetModelField, resourceData, storage, resourceLoader){
			if(!modelField['resource-picker-data']) modelField['resource-picker-data'] = {};
			resourceLoader = resourceLoader || {};
			resourceTargetModelField = resourceTargetModelField || {};

			if((modelField.config || {}).preventResourcePickerDataPreparation){
				utils.forEach(resourceData, function(resources, resourceType){
					modelField['resource-picker-data'][resourceType] = resources;
				});
			} else {
				var options = [];
				var value, name, title;

				// prepare fields which are needed within the value and name params
				var preparedFields = {};
				var matches;
				if((matches = ((modelField.config.value || '') + (modelField.config.name || '') + (modelField.config.title || '')).match(/{[\w_\-\d]+}/g))){
					for(var i in matches){
						preparedFields[matches[i].replace(/[{}]/g, '')] = new RegExp(matches[i], 'g');
					}
				}

				utils.forEach(Array.isArray(resourceData.data) ? resourceData.data : [resourceData.data], function(data){
					// define by values for value and name
					if(modelField.config.value) value = modelField.config.value + '';
					else                        value = data.attributes[data.primaryKey] + '';
					if(modelField.config.name)  name = modelField.config.name;
					else                        name = 'noNameFound';
					if(modelField.config.title) title = modelField.config.title;
					else                        title = name;

					// replace all fields within the strings
					utils.forEach(preparedFields, function(fieldRegExp, fieldKey){
						value   = value.replace(fieldRegExp, data.attributes[fieldKey] || '');
						name    = name.replace(fieldRegExp, data.attributes[fieldKey] || '');
						title 	= title.replace(fieldRegExp, data.attributes[fieldKey] || '');
					});

					// add option
					options.push({
						resource: 			data,
						title: 				title,
						name: 				name,
						value: 				value,
						defaultSelected: 	value == modelField.config.defaultSelected
					});
				});

				// set options
				modelField['resource-picker-data'].options = options;
			}

		},

		/**
		 * prepare tag pickers data according to given resourceData param.
		 *
		 * @param modelField					{} - reference to right modelField
		 * @param resourceTargetModelField 		{} - reference to modelField where the data should be stored
		 * 										NOTE: may differ according to isPicked flag.
		 * @param resourceData					{} - resourceData given by resourceAction (or serverside preloaded resourceData)
		 * @param storage       				{} - actual storage
		 * @param resourceLoader				{} - reference on resourceLoader used for picking
		 * @param [actualScope]					string - actual components' scope
		 */
		prepareTagPicker: function(modelField, resourceTargetModelField, resourceData, storage, resourceLoader, actualScope){
			resourceLoader = resourceLoader || {};
			resourceTargetModelField = resourceTargetModelField || {};
			var categoriesOptions = {};
			if(!resourceData) resourceData = {};
			var tagScopeCategories = (((resourceData.data || {}).children || {}).cms_tagScopes_categories || {}).data || [];

			var inheritedCategories = utils.prepareTagCategoryInheritanceList(resourceData.routes, resourceData.routeTags, 'parentRouteID');

			// prepare scope dependent categories
			utils.forEach(tagScopeCategories, function(tagScopeCategory){
				var categories = ((tagScopeCategory.children || {}).cms_categories || {}).data || [];
				utils.prepareCategories(categoriesOptions, categories, storage, inheritedCategories, actualScope);
			});

			// set options
			if(!modelField['tag-picker-data']) modelField['tag-picker-data'] = {};
			modelField['tag-picker-data'].ts 					= new Date().toISOString();
			modelField['tag-picker-data'].options 				= categoriesOptions;
			modelField['tag-picker-data'].inheritedCategories 	= inheritedCategories;
		},

		/**
		 * prepare resource pickers data according to given resourceData param.
		 *
		 * @param modelField					{} - reference to right modelField
		 * @param resourceTargetModelField 		{} - reference to modelField where the data should be stored
		 * 										NOTE: may differ according to isPicked flag.
		 * @param resourceData					{} - resourceData given by resourceAction (or serverside preloaded resourceData)
		 * @param storage						{} - actual storage
		 * @param resourceLoader				{} - reference on resourceLoader used for picking
		 */
		prepareRoutePicker: function(modelField, resourceTargetModelField, resourceData, storage, resourceLoader){
			//////////////// VALID OPTIONS ///////////////////
			//// pickedRouteID: 		1
			//// includePickedRoute: 	false
			//// levels: 				2
			//// prepareFullOptions: 	true
			//// hideInactivesOnly: 	false
			//// preventStatusCheck: 	false
			//////////////////////////////////////////////////

			if(!resourceData) 					resourceData = {}
			if(!resourceData.fec) 				resourceData.fec = {}
			if(!resourceData.fec.routes) 		resourceData.fec.routes = {}
			if(!resourceData.fec.routeParents) 	resourceData.fec.routeParents = {}

			resourceLoader = resourceLoader || {};
			resourceTargetModelField = resourceTargetModelField || {};
			var options = [];
			var routeParents = resourceData.fec.routeParents;
			var routes = resourceData.fec.routes;
			var route;
			var grantedRoutes = {};
			var fieldConfig = (modelField || {}).config || {};
			var prepareFullOptions = fieldConfig.prepareFullOptions === true || (((storage || {}).app || {}).service || {}).applicationType === 'cms';
			var hideInactivesOnly = fieldConfig.hideInactivesOnly === true;
			var preventStatusCheck = fieldConfig.hideInactivesOnly === true;
			var baseLevel = 0;
			var routeID;
			var target;

			if(resourceLoader.isPicked){
				target = resourceTargetModelField;
			} else {
				if(!resourceTargetModelField['route-picker-data']) resourceTargetModelField['route-picker-data'] = {};
				target = resourceTargetModelField['route-picker-data'];
			}

			var targetData = target.data;
			if(targetData === undefined && target.dataJSON !== undefined) targetData = target.dataJSON;

			// no need to prepare anything?
			if (utils.isEmpty(targetData) && !prepareFullOptions) {
				return;
			}

			if(utils.collectionSize(resourceData.data) > 0 && utils.collectionSize(routeParents) == 0){
				// sort resources by tree sort logic
				utils.sortTreeResources(resourceData, 'parentRouteID', routeParents);
			}

			if(utils.collectionSize(resourceData.data) > 0 && utils.collectionSize(routes) == 0){
				// collect id indexed list
				for(var dataIndex in (resourceData || {}).data || []){
					var route = ((resourceData || {}).data || [])[dataIndex];

					if((route || {}).attributes){
						routes[route.attributes[route.primaryKey || 'id']] = dataIndex;
					}
				}
			}

			if(fieldConfig.pickedRouteID) {
				fieldConfig.pickedRouteID = parseInt(fieldConfig.pickedRouteID);
				baseLevel = utils.collectionSize(routeParents[fieldConfig.pickedRouteID]);
			}

			// collect list of granted routeIDs (level and pickedRouteID restrictions)
			for (var routeID in routeParents){
				var routeParentsPerLevel = routeParents[routeID];

				route = (resourceData.data[routes[routeID]] || {}).attributes || {};
				if(
					// picked route check
					(
						!fieldConfig.pickedRouteID
						||
						(
							routeID == fieldConfig.pickedRouteID
							&&
							fieldConfig.includePickedRoute
						)
						||
						(
							utils.indexOf(routeParentsPerLevel, fieldConfig.pickedRouteID) > -1
						)
					)
					&&
					// level check
					(
						!fieldConfig.levels
						||
						((utils.collectionSize(routeParentsPerLevel) - baseLevel) <= fieldConfig.levels)
					)
				){
					grantedRoutes[routeID] = true;
				}
			}

			// collection granted options
			for (var dataIndex in (resourceData || {}).data || []){
				var route = resourceData.data[dataIndex];

				if(grantedRoutes[(routeID = (route || {}).attributes[(route || {}).primaryKey || 'id'])]){
					route.attributes.id = routeID;
					if (prepareFullOptions) {
						options.push(route.attributes);
					}
				}
			}

			// set options
			if (prepareFullOptions) {
				target.options = options;
			}

			// set result according to given data and options
			if(targetData){
				var option, o;
				var d, dataElements = [];
				var isList = false;

				if(utils.isCollection(targetData)){
					dataElements = targetData;
					target.result = {};
					isList = true;
				} else {
					dataElements = [targetData];
				}

				var userReferenceTS = storage.user.getReferenceTS();

				for(d in dataElements){
					routeID = dataElements[d];
					if(routeID && grantedRoutes[routeID] && (option = (resourceData.data[routes[routeID] || 0] || {}).attributes) && routeID == (option.routeID || option.id || false)){
						option.id = parseInt(routeID);
						// estimate minFuturePeriodChangeAt timestamp
						if((option.periodStart && option.periodStart > userReferenceTS && (!storage.request.minFuturePeriodChangeAt || storage.request.minFuturePeriodChangeAt > option.periodStart))){
							storage.request.minFuturePeriodChangeAt = option.periodStart;
						}
						if((option.periodEnd && option.periodEnd > userReferenceTS && (!storage.request.minFuturePeriodChangeAt || storage.request.minFuturePeriodChangeAt > option.periodEnd))){
							storage.request.minFuturePeriodChangeAt = option.periodEnd;
						}

						if(
							// status check
							preventStatusCheck
							||
							(
								option.status !== 'inactive'
								&&
								hideInactivesOnly
							)
							||
							(
								(
									(
										storage.user
										&&
										utils.isFunction(storage.user.statusVisible)
										&&
										storage.user.statusVisible(option.status)
									)
									||
									(
										(
											utils.isEmpty(option.status)
											||
											option.status === 'active'
											||
											option.status === 'preview & active'
											||
											option.status === 'invisible'
										)
									)
								)
								&&
								// period check
								(
									(
										!option.periodStart
										||
										userReferenceTS >= option.periodStart
									)
									&&
									(
										!option.periodEnd
										||
										userReferenceTS <= option.periodEnd
									)
								)
							)
						){
							if(isList){
								target.result[routeID] = option;
							} else {
								target.result = option;
							}
						}
					}
				}

				// deprecated: backwards compatibility of limited options
				if (!prepareFullOptions && target.result) {
					if(isList){
						target.options = Object.values(target.result);
					} else {
						target.options = [target.result];
					}
				}
			}
		},

		/**
		 * prepare routePickerFull data according to given resourceData param. (urls, tags, ...)
		 *
		 * @param modelField					{} - reference to right modelField
		 * @param resourceTargetModelField 		{} - reference to modelField where the data should be stored
		 * 										NOTE: may differ according to isPicked flag.
		 * @param resourceData					{} - resourceData given by resourceAction (or serverside preloaded resourceData)
		 * @param storage						{} - actual storage
		 * @param resourceLoader				{} - reference on resourceLoader used for picking
		 * @param componentInstance				{} - in case of html link replacements the componentInstance is necessary to replace the model field data by reference
		 */
		prepareRoutePickerFull: function(modelField, resourceTargetModelField, resourceData, storage, resourceLoader, componentInstance){
			resourceTargetModelField = resourceTargetModelField || {};
			resourceData = resourceData || {};
			resourceLoader = resourceLoader || {};
			var routeIndex;
			var assignedRoutes, r, refRoute, route, routeID, routeAttributes;
			var resourceTargetModelFieldData;

			if(resourceLoader.isPicked){
				resourceTargetModelFieldData = resourceTargetModelField;
			} else if(resourceLoader.isTextReplacement) {
				resourceTargetModelFieldData = resourceTargetModelField.dataTEXT;
			} else {
				resourceTargetModelFieldData = resourceTargetModelField.dataJSON;
			}

			// prevent too many loops on slave preparation
			if(!resourceData.fec) resourceData.fec = {}
			if(!resourceData.fec.refs) {
				resourceData.fec.refs = {}
				var userReferenceTS = storage.user.getReferenceTS();

				for(routeID in resourceData.data || {}){
					refRoute = resourceData.data[routeID] || {};

					// visibility check
					refRoute.visible = !!(
						(
							!refRoute.parentRouteID
							||
							(resourceData.fec.refs[refRoute.parentRouteID] || {}).visible
						)
						&& storage.user.hasAccessTo(refRoute.privilegeCode, refRoute.scope)
						&& storage.user.statusVisible(refRoute.status)
						&&
						(
							!refRoute.periodStart
							||
							refRoute.periodStart == null
							||
							userReferenceTS >= refRoute.periodStart
						)
						&&
						(
							!refRoute.periodEnd
							||
							refRoute.periodEnd == null
							||
							userReferenceTS <= refRoute.periodEnd
						)
					);

					resourceData.fec.refs[routeID] = refRoute;
				}
			}

			// prepare routes for text-replacement in html fields
			if(resourceLoader.isTextReplacement){
				var regex = new RegExp(/cmspage:\/\/([0-9]+)\$/, 'g');
				componentInstance.model[resourceLoader.target.fieldCode] = resourceTargetModelFieldData.replace(regex, function(match, elementID){
					var result = '#';
					route = resourceData.fec.refs[elementID * 1];
					if(route.visible){
						result = route.path || '#';
					}
					return result;
				});
			}
			// prepare routes for later use in templates
			else {
				for(routeIndex in resourceTargetModelFieldData || {}){
					assignedRoutes = resourceTargetModelFieldData[routeIndex];
					if(!assignedRoutes.hasSuccessfullyBeenPrepared){
						assignedRoutes.missingMainDBEntry = true;
						route = utils.simpleCopy(assignedRoutes);

						// prepare routeID dependent elements (e.g., there may be link builder elements in the future without any routeIDs which has to be prepared too.)
						if(assignedRoutes.routeID && (refRoute = resourceData.fec.refs[assignedRoutes.routeID])){
							route.resource = utils.simpleCopy(refRoute)

							// prepare route
							utils.routes.prepare(route, storage);

							// assign data to modelField
							route.hasSuccessfullyBeenPrepared = true;

							delete route.missingMainDBEntry;
						}
						// TODO: OTHER CASES

						resourceTargetModelFieldData[routeIndex] = route;
					}
				}
			}
		},

		/**
		 * prepare resource pickers data according to given resourceData param.
		 *
		 * @param modelField					{} - reference to right modelField
		 * @param resourceTargetModelField 		{} - reference to modelField where the data should be stored
		 * 										NOTE: may differ according to isPicked flag.
		 * @param resourceData					{} - resourceData given by resourceAction (or serverside preloaded resourceData)
		 * @param storage						{} - actual storage
		 * @param resourceLoader				{} - reference on resourceLoader used for picking
		 */
		prepareRouteComponentPicker: function(modelField, resourceTargetModelField, resourceData, storage, resourceLoader){
			//////////////// VALID OPTIONS ///////////////////
			//// parentRouteID || routeID || route
			//// includeParentRoute (if parentRouteID)
			//// componentID || componentList
			//////////////////////////////////////////////////

			resourceLoader = resourceLoader || {};
			resourceTargetModelField = resourceTargetModelField || {};
			var options = [];
			var routeOption = {};
			var route, routeAttributes, routeID;
			var routeComponentAttributes;
			var routes = {};
			var routeComponents = null;
			var grantedRoutes = {};
			var routeParents = false;
			var routeComponentParents = false;
			var routeRegex = false;
			var target;
			var result = {};

			var fieldConfig = (modelField || {}).config || {};
			if(fieldConfig.routeID) 									fieldConfig.routeID = parseInt(fieldConfig.routeID);
			if(fieldConfig.parentRouteID) 								fieldConfig.parentRouteID = parseInt(fieldConfig.parentRouteID);
			if(fieldConfig.componentID) 								fieldConfig.componentID = parseInt(fieldConfig.componentID);
			if(utils.collectionSize(fieldConfig.componentList) < 1)		fieldConfig.componentList = false;
			if(fieldConfig.route) 										routeRegex = new RegExp('^' + fieldConfig.route + '.+');


			// sort resources by tree sort logic if necessary
			if(!fieldConfig.routeID) {
				utils.sortTreeResources(resourceData, 'parentRouteID', routeParents = {});
			}

			// collect id indexed list
			utils.forEach((resourceData || {}).data || [], function(data, dataIndex){
				if((data || {}).attributes){
					routes[data.attributes[data.primaryKey || 'id']] = dataIndex;
				}
			});

			// collect list of granted routeIDs according to the given restrictions
			utils.forEach(routeParents || routes, function(routeParentsPerLevel, routeID){
				route = resourceData.data[routes[routeID]] || {};
				routeAttributes = route.attributes || {};
				if(
					// picked routeID check
					(
						!fieldConfig.routeID
						||
						(
							routeID === fieldConfig.routeID
						)
					)
					&&
					// picked route check (route may be parent
					(
						!routeRegex
						||
						(
							(
								fieldConfig.includeParentRoute
								&&
								routeAttributes.path === fieldConfig.route
							)
							||
							String(routeAttributes.path).match(routeRegex) !== null
						)
					)
					&&
					// parentRouteID check
					(
						!fieldConfig.parentRouteID
						||
						(
							fieldConfig.includeParentRoute
							&&
							routeID === fieldConfig.parentRouteID
						)
						||
						(
							utils.isCollection(routeParentsPerLevel) // may be dataIndex of routes
							&&
							utils.indexOf(routeParentsPerLevel, fieldConfig.parentRouteID) > -1
						)
					)
				){
					grantedRoutes[routeID] = true;
				}
			});

			// collection granted options
			utils.forEach((resourceData || {}).data || [], function(data, dataIndex){
				if((routeAttributes = (data || {}).attributes) && grantedRoutes[(routeID = routeAttributes[(data || {}).primaryKey || 'id'])]){
					routeOption = {
						routeID: 	routeID,
						path: 		routeAttributes.path,
						langCode: 	routeAttributes.langCode,
						components: []
					}

					routeComponents = (data.children || {}).rtCps || {};
					if(utils.collectionSize(routeComponents.data) > 0){
						utils.sortTreeResources(routeComponents, 'parentRouteComponentID', routeComponentParents = {});

						utils.forEach(routeComponents.data, function(routeComponent, dataIndex){
							if(
								(routeComponentAttributes = (routeComponent || {}).attributes)
								&&
								// check componentID
								(
									!fieldConfig.componentID
									||
									routeComponentAttributes.componentID == fieldConfig.componentID
								)
								&&
								// check list of componentIDs
								(
									!fieldConfig.componentList
									||
									utils.indexOf(fieldConfig.componentList, routeComponentAttributes.componentID) > -1
								)
							){
								if(resourceTargetModelField.data == (routeID + '_' + routeComponentAttributes[routeComponent.primaryKey || 'id'])){
									result.route = routeAttributes;
									result.routeComponent = routeComponentAttributes;
								}

								routeOption.components.push(routeComponentAttributes);
							}
						});
					}

					if(resourceTargetModelField.data == routeID){
						result.route = routeAttributes;
					}

					options.push(routeOption);
				}
			});

			// set options
			if(resourceLoader.isPicked){
				target = resourceTargetModelField;
			} else {
				if(!resourceTargetModelField['route-component-picker-data']) resourceTargetModelField['route-component-picker-data'] = {};
				target = resourceTargetModelField['route-component-picker-data'];
			}
			target.options = options;


			// estimate minFuturePeriodChangeAt timestamp
			var userReferenceTS = storage.user.getReferenceTS();
			if(((result.route || {}).periodStart && result.route.periodStart > userReferenceTS && (!storage.request.minFuturePeriodChangeAt || storage.request.minFuturePeriodChangeAt > result.route.periodStart))){
				storage.request.minFuturePeriodChangeAt = result.route.periodStart;
			}
			if(((result.route || {}).periodEnd && result.route.periodEnd > userReferenceTS && (!storage.request.minFuturePeriodChangeAt || storage.request.minFuturePeriodChangeAt > result.route.periodEnd))){
				storage.request.minFuturePeriodChangeAt = result.route.periodEnd;
			}
			if(((result.routeComponent || {}).periodStart && result.routeComponent.periodStart > userReferenceTS && (!storage.request.minFuturePeriodChangeAt || storage.request.minFuturePeriodChangeAt > result.routeComponent.periodStart))){
				storage.request.minFuturePeriodChangeAt = result.routeComponent.periodStart;
			}
			if(((result.routeComponent || {}).periodEnd && result.routeComponent.periodEnd > userReferenceTS && (!storage.request.minFuturePeriodChangeAt || storage.request.minFuturePeriodChangeAt > result.routeComponent.periodEnd))){
				storage.request.minFuturePeriodChangeAt = result.routeComponent.periodEnd;
			}

			if(
				(
					!result.route
					||
					// status check
					!!(
						(
							storage.user
							&&
							utils.isFunction(storage.user.statusVisible)
							&&
							storage.user.statusVisible(result.route.status)
						)
						||
						(
							(
								utils.isEmpty(result.route.status)
								||
								result.route.status === 'active'
								||
								result.route.status === 'preview & active'
								||
								result.route.status === 'invisible'
							)
						)
					)
					&&
					// period check
					(
						(
							!result.route.periodStart
							||
							userReferenceTS >= result.route.periodStart
						)
						&&
						(
							!result.route.periodEnd
							||
							userReferenceTS <= result.route.periodEnd
						)
					)
				)
				&&
				(
					!result.routeComponent
					||
					// status check
					!!(
						(
							storage.user
							&&
							utils.isFunction(storage.user.statusVisible)
							&&
							storage.user.statusVisible(result.routeComponent.status)
						)
						||
						(
							(
								utils.isEmpty(result.routeComponent.status)
								||
								result.routeComponent.status === 'active'
								||
								result.routeComponent.status === 'preview & active'
								||
								result.routeComponent.status === 'invisible'
							)
						)
					)
					&&
					// period check
					(
						(
							!result.routeComponent.periodStart
							||
							userReferenceTS >= result.routeComponent.periodStart
						)
						&&
						(
							!result.routeComponent.periodEnd
							||
							userReferenceTS <= result.routeComponent.periodEnd
						)
					)
				)
			){
				target.result = result;
			}
		},

		/**
		 * prepare resource pickers data according to given resourceData param.
		 *
		 * @param modelField					{} - reference to right modelField
		 * @param resourceTargetModelField 		{} - reference to modelField where the data should be stored
		 * 										NOTE: may differ according to isPicked flag.
		 * @param resourceData					{} - resourceData given by resourceAction (or serverside preloaded resourceData)
		 * @param storage						{} - actual storage
		 * @param resourceLoader				{} - reference on resourceLoader used for picking
		 */
		prepareCategoryPicker: function(modelField, resourceTargetModelField, resourceData, storage, resourceLoader){
			//////////////// VALID OPTIONS ///////////////////
			//// categoryID || categoryCode
			//// filterByServiceAvailableLangCodes
			//////////////////////////////////////////////////

			resourceLoader = resourceLoader || {};
			resourceTargetModelField = resourceTargetModelField || {};
			var categoryPickerData = {};
			var categoryAttributes = {};
			var categoryData = {};
			var categoryDataOption = {};
			var categoryDataAttributes = {};
			var categoryDataTrlAttributes = {};
			var availableLangCodes = (((storage.app || {}).service || {}).config || {}).availableLangCodes || {};
			var value;
			var result = {};
			var preparedFields = {};
			var matches;
			var target;

			var fieldConfig = (modelField || {}).config || {};
			if(fieldConfig.categoryID) 									fieldConfig.categoryID = fieldConfig.categoryID * 1;

			if(!fieldConfig.categoryID && !fieldConfig.categoryCode){
				console.log('MISSING_IDENTIFIER_FOR_CATEGORY_PICKER')
			}

			// prepare fields which are needed within the value params
			if((matches = String(fieldConfig.value || '').match(/{[\w_\-\d]+}/g)) && matches !== null){
				for(var i in matches){
					preparedFields[matches[i].replace(/[{}]/g, '')] = new RegExp(matches[i], 'g');
				}
			}

			utils.forEach(resourceData.data || [], function(category, dataIndex){
				if(
					(categoryAttributes = (category || {}).attributes)
					&&
					// check categoryID
					(
						!fieldConfig.categoryID
						||
						categoryAttributes[category.primaryKey || 'id'] === fieldConfig.categoryID
					)
					&&
					// check categoryCode
					(
						!fieldConfig.categoryCode
						||
						categoryAttributes.code === fieldConfig.categoryCode
					)
				){
					categoryPickerData = {
						categoryID:         categoryAttributes[category.primaryKey || 'id'],
						parentCategoryID:   categoryAttributes.parentCategoryID,
						code:               categoryAttributes.code,
						options:           []
					};

					categoryData = (category.children || {}).catData || {};
					utils.sortTreeResources(categoryData, 'parentCategoryDataID');

					utils.forEach(categoryData.data || [], function(categoryData, dataIndex){
						categoryDataAttributes = (categoryData || {}).attributes || {};
						if(
							!fieldConfig.filterByServiceAvailableLangCodes
							||
							availableLangCodes[categoryDataAttributes.value] !== undefined
						){
							// define by values for value and name
							if(fieldConfig.value) 							value = fieldConfig.value + '';
							else if(categoryDataAttributes.value === null)  value = '';
							else                  							value = categoryDataAttributes.value + '';

							// replace all fields within the strings
							utils.forEach(preparedFields, function(fieldRegExp, fieldKey){
								value = value.replace(fieldRegExp, categoryDataAttributes[fieldKey] || '');
							});

							categoryDataOption = {
								categoryDataID: 	categoryDataAttributes[categoryData.primaryKey || 'id'],
								categoryID: 		categoryDataAttributes.categoryID,
								priority: 			categoryDataAttributes.priority,
								color: 				categoryDataAttributes.color,
								config: 			categoryDataAttributes.config,
								value: 				value,
								defaultSelected: 	categoryDataAttributes.defaultSelected,
								lang: 				{}
							};

							utils.forEach(((categoryData.children || {}).cms_categoriesDataTrl || {}).data || [], function(categoryDataTrl, dataIndex){
								categoryDataTrlAttributes = (categoryDataTrl || {}).attributes || {};
								categoryDataOption.lang[categoryDataTrlAttributes.langCode] = {
									categoryDataTrlID: 	categoryDataTrlAttributes[categoryDataTrl.primaryKey || 'id'],
									categoryDataID: 	categoryDataTrlAttributes.categoryDataID,
									name: 				categoryDataTrlAttributes.name,
									description: 		categoryDataTrlAttributes.description,
									info: 				categoryDataTrlAttributes.info
								};
							});

							categoryPickerData.options.push(categoryDataOption);

							// identify selected result
							if(resourceTargetModelField.data == categoryDataOption.value){
								result.category = utils.replace(categoryPickerData, { options: undefined });
								result.categoryData = categoryDataOption;
							}
						}
					});

					return false;
				}
			});

			// set options
			if(resourceLoader.isPicked){
				resourceTargetModelField = categoryPickerData;
				target = resourceTargetModelField;
			} else {
				resourceTargetModelField['category-picker-data'] = categoryPickerData;
				target = resourceTargetModelField['category-picker-data'];
			}

			// set result according to given data and options
			if(result.category && result.categoryData) target.result = result;
		},

		/**
		 * prepare mediaImage data according to given resourceData param. (tags and mediaTrl, ...)
		 *
		 * @param modelField					{} - reference to right modelField
		 * @param resourceTargetModelField 		{} - reference to modelField where the data should be stored
		 * 										NOTE: may differ according to isPicked flag.
		 * @param resourceData					{} - resourceData given by resourceAction (or serverside preloaded resourceData)
		 * @param storage						{} - actual storage
		 * @param resourceLoader				{} - reference on resourceLoader used for picking
		 */
		prepareMediaImage: function(modelField, resourceTargetModelField, resourceData, storage, resourceLoader){
			resourceTargetModelField = resourceTargetModelField || {};
			resourceData = resourceData || {};
			resourceLoader = resourceLoader || {};
			var mediaIndex;
			var assignedMedia, m, refMedia, media, mediaID, rendered;
			var mr, amr;
			var resourceTargetModelFieldData;

			if(resourceLoader.isPicked){
				resourceTargetModelFieldData = resourceTargetModelField;
			} else {
				resourceTargetModelFieldData = resourceTargetModelField.dataJSON;
			}

			// prevent too many loops on slave preparation
			if(!resourceData.fec) resourceData.fec = {}
			if(!resourceData.fec.refs) {
				resourceData.fec.refs = {}
				for(m in resourceData.data || []){
					refMedia = resourceData.data[m] || {};
					mediaID = (refMedia.attributes || {})[refMedia.primaryKey || 'id'];
					if(mediaID) {
						resourceData.fec.refs[mediaID] = refMedia;
					}
				}
			}

			for(mediaIndex in resourceTargetModelFieldData || {}){
				assignedMedia = resourceTargetModelFieldData[mediaIndex];
				if(!assignedMedia.hasSuccessfullyBeenPrepared){
					assignedMedia.missingMainDBEntry = true;
					if(assignedMedia !== null && assignedMedia.mediaID && (refMedia = resourceData.fec.refs[assignedMedia.mediaID])){
						media = utils.simpleCopy(refMedia);

						// media defaults
						if(!media.children) 						media.children = {};
						if(!media.children.cms_assignedMedia) 		media.children.cms_assignedMedia = {};
						if(!media.children.cms_mediaRendered) 		media.children.cms_mediaRendered = {};
						if(!media.children.cms_entities_categories) media.children.cms_entities_categories = {};

						// media index
						media.attributes.index = mediaIndex;

						// assigned media data
						media.children.cms_assignedMedia = {
							data: assignedMedia.data
						};

						// collect assigned rendered media
						rendered = [];
						for(amr in assignedMedia.rendered || []){
							for(mr in (((media || {}).children || {}).cms_mediaRendered || {}).data || []){
								if(assignedMedia.rendered[amr].mediaRenderedID === (media.children.cms_mediaRendered.data[mr].attributes || {}).mediaRenderedID){
									rendered[amr] = media.children.cms_mediaRendered.data[mr];
									break;
								}
							}
						}
						media.children.cms_mediaRendered.data = rendered;

						// prepare media
						utils.media.image.prepare(media, storage, resourceLoader.useOwnMediaConfig);

						// assign data to modelField
						media.hasSuccessfullyBeenPrepared = true;

						// respect assignment pause
						if(assignedMedia.pause) media.pause = true

						resourceTargetModelFieldData[mediaIndex] = media;
					}
				}
			}
		},

		/**
		 * prepare mediaFile data according to given resourceData param. (tags and mediaTrl, ...)
		 *
		 * @param modelField					{} - reference to right modelField
		 * @param resourceTargetModelField 		{} - reference to modelField where the data should be stored
		 * 										NOTE: may differ according to isPicked flag.
		 * @param resourceData					{} - resourceData given by resourceAction (or serverside preloaded resourceData)
		 * @param storage						{} - actual storage
		 * @param resourceLoader				{} - reference on resourceLoader used for picking
		 */
		prepareMediaFile: function(modelField, resourceTargetModelField, resourceData, storage, resourceLoader){
			resourceTargetModelField = resourceTargetModelField || {};
			resourceData = resourceData || {};
			resourceLoader = resourceLoader || {};
			var mediaIndex;
			var assignedMedia, m, refMedia, media, mediaID;
			var resourceTargetModelFieldData;

			if(resourceLoader.isPicked){
				resourceTargetModelFieldData = resourceTargetModelField;
			} else {
				resourceTargetModelFieldData = resourceTargetModelField.dataJSON;
			}

			// prevent too many loops on slave preparation
			if(!resourceData.fec) resourceData.fec = {}
			if(!resourceData.fec.refs) {
				resourceData.fec.refs = {};
				for(m in resourceData.data || []){
					refMedia = resourceData.data[m] || {};
					mediaID = (refMedia.attributes || {})[refMedia.primaryKey || 'id'];
					if(mediaID) resourceData.fec.refs[mediaID] = refMedia;
				}
			}

			for(mediaIndex in resourceTargetModelFieldData || {}){
				assignedMedia = resourceTargetModelFieldData[mediaIndex];
				assignedMedia.missingMainDBEntry = true;
				if(assignedMedia !== null && assignedMedia.mediaID && (refMedia = resourceData.fec.refs[assignedMedia.mediaID])){
					media = utils.simpleCopy(refMedia);

					// media defaults
					if(!media.children) 						media.children = {};
					if(!media.children.cms_entities_categories) media.children.cms_entities_categories = {};

					// media index
					media.attributes.index = mediaIndex;

					// prepare media
					utils.media.file.prepare(media, storage, resourceLoader.useOwnMediaConfig);

					// assign data to modelField
					resourceTargetModelFieldData[mediaIndex] = media;
				}
			}
		}
	},

	///////////////////////////////////////////////
	///// MODEL HELPERS
	///////////////////////////////////////////////


	/**
	 * this function is useful if a parent-component has to handle mutliple standard buttons.
	 *
	 * @param   event                           {} - actual dom-click-event
	 * @param   actionBossComponentClass        string - closest potential action-boss-component
	 * @param   additionalData                  {} - additionalData to pass to the actions or function-calls
	 * @param   buttonData						{} - in case of manual triggers without an event this flag can contain all necessary information about the buttons' definition
	 * @param   [isOptional]					boolean - default: false - prevent console.errors on optional button actions
	 * @return  Promise
	 */
	performButtonAction: function(event, actionBossComponentClass, additionalData, buttonData, isOptional){
		if(!event && !buttonData) return utils.promise.reject('no event found');

		if(event){
			buttonData = {};

			var target = event.originalEvent ? event.originalEvent.target : event.target;
			buttonData.type = target.nodeName.toLowerCase();

			// take icons parents automatically
			if(buttonData.type === 'i'){
				target = utils.$(target).parent()[0];
				buttonData.type = target.nodeName.toLowerCase();
			}

			buttonData.fieldType			= target.dataset.fieldType;
			buttonData.context      		= target.dataset.buttonContext;
			buttonData.mode         		= target.dataset.buttonMode;
			buttonData.componentInCharge 	= event.data.component;
		}
		else if(buttonData){
			buttonData.type = 'button';
			if(!buttonData.fieldType || !buttonData.componentInCharge) return utils.promise.reject('invalid buttonData found');
		}

		var promise;
		var resolveData = {
			actionPerformed:    false,
			fieldType:          buttonData.fieldType,
			additionalData:     additionalData
		};

		switch (buttonData.type) {
			case 'button':
				buttonData.potentialActionKey = buttonData.fieldType;
				if(buttonData.context) buttonData.potentialActionKey += '_' + buttonData.context;

				var actionBossComponent;
				buttonData.componentInCharge.closest(buttonData.componentInCharge.config.actionBossComponentClass, function(parentComponent){
					actionBossComponent = parentComponent;
				});

				resolveData.buttonContext 			= buttonData.context;
				resolveData.buttonMode 				= buttonData.mode;
				resolveData.potentialActionKey 		= buttonData.potentialActionKey;
				resolveData.actionBossComponent 	= actionBossComponent;

				// this action form should handle the operation by itself.
				if(utils.isFunction(buttonData.componentInCharge[buttonData.fieldType])){
					promise = buttonData.componentInCharge[buttonData.fieldType](buttonData.potentialActionKey, buttonData.context, buttonData.mode, actionBossComponent, additionalData);
				}
				// default actions of this action form can be performed without operation function too
				else if(buttonData.componentInCharge.actions[buttonData.potentialActionKey] != undefined){
					promise = buttonData.componentInCharge.performAction(buttonData.componentInCharge.prepareAction(buttonData.potentialActionKey, undefined, { additionalData: additionalData }));
				}
				// actionBossComponent should handle the operation
				else if(actionBossComponent != undefined && utils.isFunction(actionBossComponent[buttonData.fieldType])){
					promise = actionBossComponent[buttonData.fieldType](buttonData.potentialActionKey, buttonData.context, buttonData.mode, actionBossComponent, additionalData);
				}
				// default actions of actionBossComponent can be performed without operation function too
				else if(actionBossComponent != undefined && actionBossComponent.actions[buttonData.potentialActionKey] != undefined){
					promise = actionBossComponent.performAction(actionBossComponent.prepareAction(buttonData.potentialActionKey, undefined, { additionalData: additionalData }));
				}
				else if (!isOptional) {
					console.error('button action not found: ' + buttonData.potentialActionKey);
				}
				break;
		}

		if(promise){
			if(utils.isFunction(promise.then)){
				resolveData.actionPerformed = true;
				return promise.then(function(context){
					resolveData.response = (context || {}).response;
					return utils.promise.resolve(resolveData);
				});
			} else {
				resolveData.response = promise;
			}
		}

		return utils.promise.resolve(resolveData);
	},

	/**
	 * this function is used to return the right attributeKey according to the given dataType of an atom.
	 *
	 * @param   dataType        string - atom dataType
	 * @returns                 string - key according to dataType
	 */
	getDataValueKey: function(dataType){
		switch(dataType){
			// ['text','integer','float','date','time','datetime','html','media-file','media-image','boolean','route-picker','db-picker','table'],
			case 'uuid':
			case 'template-picker':
			case 'html':
			case 'text':            return 'dataTEXT';
			case 'boolean':
			case 'integer':         return 'dataINT';
			case 'float':           return 'dataFLOAT';
			case 'time':			return 'dataTIME';
			case 'datetime':
			case 'date':            return 'dataDATE';
			case 'json':
			case 'select':
			case 'route-picker':
			case 'resource-picker':
			case 'tag-picker':
			case 'media-image':
			case 'media-file':
			default:                return 'dataJSON';
		}
	},

	/**
	 * prepare categories and write the conclusion to the given categoriesOptions reference.
	 * NOTE: this function may be used for two different data structures:
	 * 		1. cms_categories->catData->...
	 * 		2. cms_entities_categories->catData->...
	 *
	 * @param categoriesOptions			{} - reference to categoriesOptionsTargetVariable
	 * @param categories				[] - resourceData categories to prepare
	 * @param storage       			{} - actual storage
	 * @param [inheritedCategories]		{} - inherited categories
	 * @param [actualScope]				string - actual components' scope
	 * @param [preventSortIndex=false]	boolean - should the elements index be defined by elements' id only?
	 */
	prepareCategories: function(categoriesOptions, categories, storage, inheritedCategories, actualScope, preventSortIndex){
		inheritedCategories = inheritedCategories || {};
		var langCode = (((storage || {}).user || {}).data || {}).langCode || 'de-at';
		var categoryAttributes, categoryDataAttributes, categoryDataID, categoryIndex, categoryDataIndex, categoriesDataOptions;
		var categoriesData, categoryDataParents, fullCategoryDataParents, categoriesDataName, categoriesDataTrl, categoriesName, categoriesTrl;
		var categoryDataIndexChain, categoryDataIndexChains;
		var subCategory, tagScope, tagScopes, tagScopeCode;
		var turnedOffTagCategoryManagement = storage.user ? storage.user.hasAccessTo('usage:turnedOffTagCategoryManagement', actualScope) : false;
		utils.forEach(utils.isArray(categories) ? categories : [categories], function(category){

			if(category !== null){
				categoryAttributes = category.attributes || {}
				if(preventSortIndex === true) 	categoryIndex = categoryAttributes['categoryID' || 'id' || 0]
				else 							categoryIndex = (categoryAttributes.sort || 0) + '_' + categoryAttributes['categoryID' || 'id' || 0]

				categoriesName = '';
				categoriesTrl = ((category.children || {}).cms_categoriesTrl || {}).data || [];
				utils.forEach(categoriesTrl, function(categoryTrl){
					if ((categoryTrl.attributes || {}).langCode === langCode) {
						categoriesName = categoryTrl.attributes.name;
						return false;
					}
				})

				// just if this function will be used to prepare "cms_entities_categories"
				// this is the way to prepare the real category and tagScope attributes.
				subCategory = ((category.children || {}).cms_categories || {}).data || {}
				if(!categoriesName) categoriesName = categoryAttributes.code || (subCategory.attributes || {}).code || 'NO-CATEGORY-NAME-FOUND';

				if(!categoriesOptions[categoryIndex]) {
					categoriesOptions[categoryIndex] = {
						id: 								categoryAttributes[category.primaryKey || 0] || null,
						name: 								categoriesName,
						turnedOff: 							false,
						turnedOn: 							false,
						turnedOffByInheritance: 			false,
						turnedOffTagCategoryManagement: 	turnedOffTagCategoryManagement,
						children: 							{},
						resources: 							categoryAttributes,
						tagScopes: 							{}
					}
				}
				categoriesOptions[categoryIndex].turnedOff =
					categoriesOptions[categoryIndex].turnedOff ||
					(category.primaryKey === 'entityCategoryID' && categoryAttributes.categoryDataID === null ? (categoryAttributes.enabled !== true) : false)
				;
				categoriesOptions[categoryIndex].turnedOn =
					categoriesOptions[categoryIndex].turnedOn ||
					(category.primaryKey === 'entityCategoryID' && categoryAttributes.categoryDataID === null ? (categoryAttributes.enabled === true) : false)
				;
				categoriesOptions[categoryIndex].turnedOffByInheritance =
					categoriesOptions[categoryIndex].turnedOffByInheritance ||
					inheritedCategories[categoriesOptions[categoryIndex].resources.categoryID || 0] === false // undefined || false || true
				;

				// just if this function will be used to prepare "cms_entities_categories"
				// this is the way to prepare the real category and tagScope attributes.
				tagScope = {}
				tagScopes = {}
				tagScopeCode = ''
				utils.forEach(((subCategory.children || {}).cms_tagScopes_categories || {}).data || [], function(tagScopeCategory){
					if(tagScopeCategory.attributes && (tagScope = (((tagScopeCategory.children || {}).cms_tagScopes || {}).data || {}).attributes || {}) && (tagScopeCode = tagScope.code)){
						if(!categoriesOptions[categoryIndex].tagScopes[tagScopeCode]){
							categoriesOptions[categoryIndex].tagScopes[tagScopeCode] = {
								resources: tagScope
							}
						}
					}
				})

				// prepare categoriesData
				categoriesDataOptions = []
				categoriesData = ((category.children || {}).catData || {}).data || []

				categoryDataParents = {}
				categoryDataIndexChains = {}
				fullCategoryDataParents = {}
				utils.prepareListOfParents((utils.isArray(categoriesData) ? categoriesData : [categoriesData]), 'parentCategoryDataID', categoryDataParents, fullCategoryDataParents);

				utils.forEach((utils.isArray(categoriesData) ? categoriesData : [categoriesData]), function(categoryData){
					categoryDataAttributes = categoryData.attributes || {}
					categoryDataID = categoryDataAttributes[categoryData.primaryKey || 0] || null
					if(preventSortIndex === true) 	categoryDataIndex = categoryDataID
					else 							categoryDataIndex = (categoryDataAttributes.sort || 0) + '_' + categoryDataID
					categoriesDataName = '';
					categoriesDataTrl = ((categoryData.children || {}).cms_categoriesDataTrl || {}).data || [];
					utils.forEach(categoriesDataTrl, function(categoryDataTrl){
						if ((categoryDataTrl.attributes || {}).langCode === langCode) {
							categoriesDataName = categoryDataTrl.attributes.name;
							return false;
						}
					})
					if(!categoriesDataName) categoriesDataName = categoryDataAttributes.value || 'NO-CATEGORY-DATA-NAME-FOUND';

					if(!categoriesOptions[categoryIndex].children[categoryDataIndex]){

						if (categoryDataAttributes.parentCategoryDataID > 0 && categoryDataIndexChains[categoryDataAttributes.parentCategoryDataID]){
							categoryDataIndexChain = utils.copy(categoryDataIndexChains[categoryDataAttributes.parentCategoryDataID]);
						} else {
							categoryDataIndexChain = {}
						}
						categoryDataIndexChains[categoryDataID] = categoryDataIndexChain;
						categoryDataIndexChains[categoryDataID][utils.collectionSize(categoryDataIndexChains[categoryDataID])] = categoryDataIndex;

						categoriesOptions[categoryIndex].children[categoryDataIndex] = {
							id: 			categoryDataID,
							name: 			categoriesDataName,
							level: 			utils.collectionSize(categoryDataParents[categoryDataID] || {}),
							indexChain:  	categoryDataIndexChains[categoryDataID],
							children: 		(fullCategoryDataParents[categoryDataID] || {}).children || {},
							nrOfChildren: 	utils.collectionSize((fullCategoryDataParents[categoryDataID] || {}).children || {}),
							resources: 		categoryDataAttributes
						}
					}
				});
			}
		});
	},

	/**
	 * get a list of entities' categories and their inheritance values.
	 *
	 * @param resources			{} - resources (e.g., routes) which should be the entities
	 * @param tagResources		{} - tagResources (cms_entities_categories)
	 * @param parentIDKey		String - parentIDKey name (e.g., "parentRouteID")
	 * @param [refParents]		{} - 	if this flag is given the list of level ordered parents of the resources' entities
	 * 									will be written to this var-reference.
	 * 									NOTE: the level ordered list is starting with { zero: zero, ... } which means <zero level>: <zero routeID of virtual root-leaf>
	 * @returns {} - categoryInheritanceValues
	 */
	prepareTagCategoryInheritanceList: function(resources, tagResources, parentIDKey, refParents){
		// prepare list of parents level ordered (root to leaf) for each route if necessary
		var parents = {};
		if(refParents) parents = refParents
		utils.prepareListOfParents((resources || {}).data || [], parentIDKey || 'parentRouteID', parents);
		var categories = {};
		var inheritedCategories = {};
		var tagAttributes;

		// prepare list of categories' enabled state for each route and category
		utils.forEach((tagResources || {}).data || [], function(tag){
			tagAttributes = tag.attributes || {};
			if(tagAttributes.categoryDataID === null && tagAttributes.entityType === 'routes'){
				if(!categories[tagAttributes.entityID]) categories[tagAttributes.entityID] = {};
				categories[tagAttributes.entityID][tagAttributes.categoryID] = tagAttributes.enabled === true;
			}
		});

		// prepare inherited categories' enabled values for all routes according to their parents
		utils.forEach(parents, function(parent, id){
			inheritedCategories[id] = {};
			utils.forEach(parent, function(parentID, level){
				utils.forEach(categories[parentID] || {}, function(enabled, categoryID){
					inheritedCategories[id][categoryID] = enabled
				});
			});
		});

		return inheritedCategories;
	},

	/**
	 * returns a list of parents within a resource-structure given by key and parentKey (e.g., routeID and parentRouteID).
	 * NOTE: the key will be estimated as the primaryKey.
	 *
	 * @param resourceData		{} - resourceData of entities
	 * @param parentIDKey		String - parentIDKey name (e.g., "parentRouteID")
	 * @param [refList]			{} - 	if this flag is given the list of level ordered parents of the resources' entities
	 * 									will be written to this var-reference.
	 * 									NOTE: the level ordered list is starting with { zero: zero, ... } which means <zero level>: <zero routeID of virtual root-leaf>
	 * @param [refOriginalList]	{} - 	if this flag is given the original list including parents, children, levels, levelDiffs will be stored within this parameter.
	 */
	prepareListOfParents: function(resourceData, parentIDKey, refList, refOriginalList){
		parentIDKey = parentIDKey || 'parentRouteID'

		var list = {};
		var cleanList = {};
		if(refOriginalList) list = refOriginalList;
		if(refList) 		cleanList = refList;
		var id, parentID, maxLevel;

		if(utils.collectionSize(resourceData) === 0) return cleanList;

		for(var entry of resourceData || []){
			id = entry.attributes[entry.primaryKey || 0];
			parentID = entry.attributes[parentIDKey] || 0;
			list[id] = {
				children: {},
				parents: {},
				levels: {},
				levelDiff: {}
			};
			list[id].parents[parentID] = 1;
			list[id].levelDiff[1] = parentID;
		}

		for(var entry of resourceData || []){
			id = entry.attributes[entry.primaryKey];
			parentID = entry.attributes[parentIDKey];
			utils.prepareParent(list, id, parentID);
		}

		for(var elementID in list || {}){
			var element = list[elementID];
			maxLevel = (element.parents || {})[0];
			utils.forEachReverse(element.levelDiff || {}, function(parentID, levelDiff){
				list[elementID].levels[maxLevel - levelDiff] = parseInt(parentID);
			});

			cleanList[elementID] = list[elementID].levels;
		}

		return cleanList;
	},

	/**
	 * this is a recursive helper function of prepareListOfParents and collects all
	 * information needed to build a list of entities and their parents.
	 *
	 * @param list			{} - referential list of entities
	 * @param id			Mixed - id of entity
	 * @param parentID		Mixed - parentID of entity
	 * @param levelDiff		Integer - level difference counter used for function internal purposes only.
	 */
	prepareParent: function(list, id, parentID, levelDiff){
		if(!list[id]) list[id] = { children: {}, parents: {}, levels: {}, levelDiff: {} };
		if(!levelDiff) levelDiff = 1;
		if(parentID){
			if(!list[parentID]) list[parentID] = { children: {}, parents: {}, levels: {}, levelDiff: {} };

			list[parentID].children[id] = 1;
			list[id].parents[parentID] = levelDiff;
			list[id].levelDiff[levelDiff] = parentID;

			for(var pID in (list[parentID] || {}).parents || {}){
				utils.prepareParent(list, id, pID, levelDiff + 1)
			}
		}
	},

	/**
	 * sorts resources' data list according to a tree sort defined by parentIDKey and sortKey
	 *
	 * @params 	refResources		{ data: [...] } - resources
	 * @params 	parentIDKey			string - fieldname of parentID attribute
	 * @params 	[refParents]		list of entities' parents per level
	 * @params 	[sortKey]			string - fieldname of sort attribute
	 */
	sortTreeResources: function(refResources, parentIDKey, refParents, sortKey){
		// init
		if(!(refResources || {}).data) return false;
		if(!sortKey) sortKey = 'sort';

		var entityParentsPerLevel = {};
		if(refParents) entityParentsPerLevel = refParents;
		var entity;
		var entities = {};
		var entityAttributes, entityID;

		// prepare list of parents
		utils.prepareListOfParents(refResources.data, parentIDKey, entityParentsPerLevel);

		// create a list of entities per menu-item (categoryData)
		for(var entityIndex in refResources.data || []){
			entity = refResources.data[entityIndex];

			entityAttributes = entity.attributes || {};
			entityID = entityAttributes[entity.primaryKey];
			entities[entityID] = entity;
		}

		// prepare sortKeys which are valid across the whole entityTree
		for(var entityID in entityParentsPerLevel){
			var entityLevels = entityParentsPerLevel[entityID];
			if(entities[entityID]){
				entities[entityID].sortKey = [];
				entities[entityID].realLevel = utils.collectionSize(entityLevels);
				entities[entityID].level = entities[entityID].realLevel;
				for(var level in entityLevels){
					var parentEntityID = entityLevels[level];

					// level 0 means root (virtual root of all nodes)
					if(level > 0 && (entities[parentEntityID] || {}).attributes){
						entities[entityID].sortKey.push(String(entities[parentEntityID].attributes[sortKey]).padStart(16, '0'));
					}
				}
				entities[entityID].sortKey.push(String(((entities[entityID] || {}).attributes || {})[sortKey] || 'UNKNOWN-OWN-SORT-KEY').padStart(16, '0'));
				entities[entityID].sortKey = entities[entityID].sortKey.join('-');
			}
		}

		// sort entities
		refResources.data.sort(function(a, b){
			if(a.sortKey < b.sortKey) return -1;
			if(a.sortKey === b.sortKey) return 0;
			return 1;
		});

		return true;
	},


	///////////////////////////////////////////////
	///// STRING HELPERS
	///////////////////////////////////////////////

	/**
	 * this function is used to return the given text with the first letter being transformed to uppercase.
	 *
	 * @param 	text		string - text
	 * @returns string - text upperCaseFirstLetter
	 */
	ucFirst: function(text){
		return typeof(text) === 'string' && text != '' ? text.charAt(0).toUpperCase() + text.slice(1) : '';
	},

	/**
	 * this function returns a human readable key according to the given value.
	 *
	 * @param 		value		string - value
	 * @returns		string - key
	 */
	getKeyFromValue: function(value){
		return (value || '').replace(/[^0-9a-zA-Z]+/g, '-');
	},

	/**
	 * version of PHP's strip_tags
	 *
	 * @param html
	 * @param allowed_tags
	 * @param tag_replacement
	 * @returns {*}
	 */
	stripTags: function(html, allowed_tags, tag_replacement){
		return striptags(html, allowed_tags, tag_replacement);
	},

	decodeHTMLEntities: function(html){
		var entities = new HTMLEntities();
		return entities.decode(html);
	},

	///////////////////////////////////////////////
	///// ERROR HELPERS
	///////////////////////////////////////////////

	/**
	 * this function is used to extract as exact as possible the base error out of childErrors and cascading errors.
	 * 
	 * @param   error       {} - error 
	 * @return  {} - baseError or given error if no baseError has been found
	 */
	extractBaseError: function(error){
		if(!this.isEmpty(error) && this.isCollection(error)){
			if(!utils.isEmpty(error.childErrors) && Array.isArray(error.childErrors)){
				return this.extractBaseError(error.childErrors[0]);
			}
			else if(!utils.isEmpty(error.error) && utils.isCollection(error.error)){
				return this.extractBaseError(error.error);
			}
			else {
				if(error.code && !error.errorCode)      error.errorCode = error.code;
				if(error.status && !error.statusCode)   error.statusCode = error.status;
			}
		}

		return error;
	},

	/**
	 * this function returns true if the given error is an error which has been thrown because of an invalid user, not logged in user or user with insufficient rights.
	 *
	 * @param 		error		{} - error object
	 * @returns 	boolean
	 */
	isLoggedInError: function(error){
		return (
			error
			&&
			error.statusCode == 403
			&&
			(
				error.errorCode === 'API_PRIVILEGE_ERROR_1'
				||
				error.errorCode === 'API_PRIVILEGE_ERROR_2'
				||
				error.errorCode === 'API_PRIVILEGE_ERROR_3'
				||
				error.errorCode === 'API_PRIVILEGE_ERROR_4'
				||
				error.errorCode === 'API_PRIVILEGE_ERROR_5'
			)
		);
	},



	///////////////////////////////////////////////
	///// DOM HELPERS
	///////////////////////////////////////////////

	dom: {
		getHtmlFieldValue: function(fieldType, target){
			switch(fieldType){
				case 'text':
				case 'textarea':
				case 'select':
				case 'radio':
					return target.value;
					break;

				case 'checkbox':
					return ((!!target.checked) * 1);
					break;
			}
		}
	},



	///////////////////////////////////////////////
	///// SERVER HELPERS
	///////////////////////////////////////////////

	/**
	 * this function is used to get the domain out of the express-request-host header
	 *
	 * @param   host        string - express-request-host
	 * @returns             string - domain
	 */
	hostToDomain: function(host){
		return (host || '').split(':')[0];
	},

	/**
	 * this function is used to initialize session- and user-data.
	 * NOTE:    this function operates only on the express-request-object.
	 *          not on the storage object!!!
	 *
	 * @param   req         {} - express request object
	 * @param   appConfig   {} - actual appConfig
	 * @param   storage     {} - actual storage
	 */
	initSession: function(req, appConfig, storage){
		// init
		if(!storage.session)        						storage.session = {};
		if(!storage.session.user)   						storage.session.user = {};
		if(!storage.session.data)   						storage.session.data = {};

		// define user language
		if(!storage.session.user.langCode){
			var availableLangCodes;
			if(storage && storage.app && storage.app.service && storage.app.service.config && !utils.isEmpty(storage.app.service.config.availableLangCodes)){
				availableLangCodes = storage.app.service.config.availableLangCodes;
			}
			if(availableLangCodes){
				storage.session.user.langCode = req.acceptsLanguages.apply(req, [Object.keys(availableLangCodes)]);
			}
		}

		// define users' serviceDomain
		if(!storage.session.user.serviceDomain){
			storage.session.user.serviceDomain = utils.hostToDomain(req.headers.host);
		}

		// define users' device
		if(!storage.session.user.environment){
			storage.session.user.environment = {};
		}
		if(!storage.session.user.environment.device && req.device){
			storage.session.user.environment.device = {
				type: req.device.type,
				name: req.device.name
			};
		}

		// define users' cookiePrivacy
		if(!storage.session.data.cookiePolicy){
			storage.session.data.cookiePolicy = {
				acceptTracking: ((((appConfig || {}).store || {}).cookie || {}).policy || {}).acceptTrackingDefault || null
			}
		}
	},

	/**
	 * this function is used to initialize the developer mode within the storage if necessary.
	 * NOTE: this will not be done if the serviceAppConfig has no developerMode flag or the processes' NODE_ENV is equal to 'production'.
	 *
	 * @param storage       {} - actual storage
	 * @param appConfig     {} - actual appConfig
	 * @param req           {} - express request object
	 * @param nodeEnv       string - process.env.NODE_ENV
	 */
	initDeveloperMode: function(storage, appConfig, req, nodeEnv){
		if(nodeEnv !== 'production'){
			var serviceDomain = utils.hostToDomain(req.headers.host || appConfig.serviceDomainFallback);
			if(appConfig.services[serviceDomain] && appConfig.services[serviceDomain].developerMode){
				storage.app.service.developerMode = true;
			}
		}
	},

	/**
	 * this function is used to generate the sitemap according to the given routes
	 *
	 * @param routes            {} - list of routes with routeID as keys
	 * @param refreshTS         string - timestamp in ISO-8601 which should be used for lastModifiedTS
	 * @param storage           {} - actual storage
	 */
	writeSiteMapXML: function(storage, routes, refreshTS, baseUrl, stream, writeHeader = true, writeFooter = true){
		var r, route, priority;
		if(!baseUrl || !stream) return;

		if(writeHeader) stream.write(SITEMAP_HEADER);

		for(r in routes){
			route = routes[r];
			if(route.isHome){
				priority = 1;
			}
			else {
				priority = Math.round((0.9 / Math.max(1, route.depth + 1)) * 1000) / 1000;
			}

			stream.write(`<url><loc>${baseUrl + route.path}</loc><priority>${priority}</priority><lastmod>${route.lastChange || refreshTS}</lastmod><changefreq>weekly</changefreq></url>`)
		}

		if(writeFooter) stream.write(SITEMAP_FOOTER);
	},



	///////////////////////////////////////////////
	///// ENVIRONMENT HELPERS
	///////////////////////////////////////////////

	environmentTimeouts: {
		clientRefresh: undefined,
		serverRefresh: undefined
	},

	/**
	 * this function is used to initialize the environment
	 *
	 * @param   storage {} - actual storage
	 * @param   device  {} - device recognized by express-device
	 */
	initEnvironment: function(storage, device){
		// init
		if(!storage) return;

		// set active skip options
		var activeSkipLoadingOptions;
		if(storage.app && storage.app.service && storage.app.service.config && storage.app.service.config.media && storage.app.service.config.media.skipLoadingOptions){
			activeSkipLoadingOptions = storage.app.service.config.media.skipLoadingOptions;
		}
		var activeEnvironment = {
			skipLoadingOptions: false,
			breakPoint: 'm',
			breakPointSize: 0,
			dimensions: {
				window: {
					width: -1,
					height: -1
				}
			},
			device: {
				type: device && device.type || 'desktop',
				name: device && device.name || ''
			}
		};
		if(storage.session && storage.session.user && storage.session.user.environment){
			utils.refMerge(activeEnvironment, storage.session.user.environment);
		}

		// define if loadingOptions of images should be skipped
		if(activeEnvironment.device.type) {
			if (activeSkipLoadingOptions) {
				if(activeSkipLoadingOptions.devices && activeSkipLoadingOptions.devices[activeEnvironment.device.type]){
					if(activeSkipLoadingOptions.devices[activeEnvironment.device.type] === true){
						activeEnvironment.skipLoadingOptions = true;
					}
					else if(activeSkipLoadingOptions.devices[activeEnvironment.device.type].breakPoints && activeSkipLoadingOptions.devices[activeEnvironment.device.type].breakPoints[activeEnvironment.breakPoint]){
						activeEnvironment.skipLoadingOptions = true;
					}
				}
			}
			else if (activeEnvironment.dimensions.window.width >= 0) {
				activeEnvironment.skipLoadingOptions = true;
			}
		}

		storage.session.user.serverKnownEnvironment = activeEnvironment;
	},

	/**
	 * this function is used to refresh all environment dependent parameters, saves them within storage and call the
	 * given update callback if defined.
	 *
	 * @param initialExecution              boolean - is this the very first execution
	 * @param externalDrivenCall            boolean - has this refresh been invoked by external events (like resize or orientation change, ...)
	 * @param store                         Store - actual store
	 * @param storage                       {} - actual storage
	 * @param onUpdateCallback              function - optional - on update callback function
	 * @param onUpdateCallbackContext       {} - optional - context for on update callback function
	 * @param environmentExtension          {} - optional - static data which should be merged on the caculated environment
	 * @param isLandscape					boolean - optional - orientation is landscape (default: true)
	 * @private
	 */
	_refreshEnvironment: function(initialExecution, externalDrivenCall, store, storage, onUpdateCallback, onUpdateCallbackContext, environmentExtension, isLandscape){
		// init
		initialExecution = !!initialExecution;
		externalDrivenCall = !!externalDrivenCall;

		// refresh environment at most each serviceConfig.media.deltaEnvironmentUpdate milliseconds
		var layout;
		var environment = {};
		var serverKnownEnvironment;
		var mediaConfig;
		var styles, style;

		if (storage) {
			if (storage.user && storage.user.data) {
				if(storage.user.data.environment){
					environment = storage.user.data.environment;
				}
				if(storage.user.data.serverKnownEnvironment){
					serverKnownEnvironment = storage.user.data.serverKnownEnvironment;
				}
			}
			if (storage.app && storage.app.service && storage.app.service.config && storage.app.service.config.media) {
				mediaConfig = storage.app.service.config.media;
				if(mediaConfig.layout){
					layout = mediaConfig.layout;
				}
				if(mediaConfig.styles){
					styles = mediaConfig.styles;
				}
				if(mediaConfig.style){
					style = mediaConfig.style;
				}
			}
		}
		// update environment
		environment.dimensions      = utils.getDimensions(isLandscape);
		environment.breakPoint      = utils.getBreakPoint(environment, layout);
		environment.breakPointSize  = 0;
		environment.style           = utils.getStyle(environment.breakPoint, (environment.device || {}).type, style);
		if(environmentExtension){
			utils.refReplace(environment, environmentExtension);
		}

		// estimate breakPointSize
		if(layout){
			if(layout[(environment.device || {}).type]){
				if(layout[(environment.device || {}).type][environment.breakPoint]){
					environment.breakPointSize = layout[(environment.device || {}).type][environment.breakPoint];
				}
				else {
					environment.breakPointSize = layout[(environment.device || {}).type];
				}
			}
			else if(layout[environment.breakPoint]){
				environment.breakPointSize = layout[environment.breakPoint];
			}
		}

		// save environment within local storage
		storage.user.data.environment = environment;

		if(typeof(onUpdateCallback) === 'function'){
			onUpdateCallback.apply(onUpdateCallbackContext || window, [initialExecution, storage, styles, serverKnownEnvironment, environment, externalDrivenCall]);
		}
	},


	/**
	 * this function is used to refresh all environment dependent parameters, saves them within storage and call the
	 * given update callback if defined.
	 * NOTE: after the configured amount if time this function tells the server the new environment of this client.
	 *
	 * @param initialExecution              boolean - is this the very first execution
	 * @param externalDrivenCall            boolean - has this refresh been invoked by external events (like resize or orientation change, ...)
	 * @param store                         Store - actual store
	 * @param storage                       {} - actual storage
	 * @param onUpdateCallback              function - optional - on update callback function
	 * @param onUpdateCallbackContext       {} - optional - context for on update callback function
	 * @param environmentExtension          {} - optional - static data which should be merged on the caculated environment
	 * @param executeImmediatly             boolean - optional - should the environment be refreshed immediately or should be waited until the configured refresh timeout has been reached.
	 * @param isLandscape					boolean - optional - orentation is landscape (default: true)
	 */
	refreshEnvironment: function(initialExecution, externalDrivenCall, store, storage, onUpdateCallback, onUpdateCallbackContext, environmentExtension, executeImmediatly, isLandscape){
		// init
		var serviceMediaConfig = storage.app.service.config.media;
		initialExecution = !!initialExecution;
		executeImmediatly = !!executeImmediatly;
		externalDrivenCall = !!externalDrivenCall;
		isLandscape = isLandscape === undefined || !!isLandscape;

		// refresh environment at most each serviceConfig.media.deltaEnvironmentUpdate milliseconds
		if(initialExecution || executeImmediatly) {
			utils._refreshEnvironment(initialExecution, externalDrivenCall, store, storage, onUpdateCallback, onUpdateCallbackContext, environmentExtension, isLandscape);
		}
		else {
			if (utils.environmentTimeouts.clientRefresh) clearTimeout(utils.environmentTimeouts.clientRefresh);
			utils.environmentTimeouts.clientRefresh = setTimeout(function (initialExecution, externalDrivenCall, store, storage, onUpdateCallback, onUpdateCallbackContext, environmentExtension, isLandscape) {
				utils._refreshEnvironment(initialExecution, externalDrivenCall, store, storage, onUpdateCallback, onUpdateCallbackContext, environmentExtension, isLandscape);
			}, serviceMediaConfig.deltaEnvironmentUpdate || 100, initialExecution, externalDrivenCall, store, storage, onUpdateCallback, onUpdateCallbackContext, environmentExtension, isLandscape);
		}

		// tell server new dimensions at most each serviceConfig.media.deltaEnvironmentServerUpdate milliseconds
		if (utils.environmentTimeouts.serverRefresh) clearTimeout(utils.environmentTimeouts.serverRefresh);
		utils.environmentTimeouts.serverRefresh = setTimeout(function (environment) {
			return utils.$.ajax({
				url: '/clientInterface/environment',
				method: 'POST',
				data: JSON.stringify(environment)
			});
		}, initialExecution || executeImmediatly ? 1 : serviceMediaConfig.deltaEnvironmentServerUpdate || 5000, storage.user.data.environment);
	},

	/**
	 * this function is used to return the dimensions of the browser window.
	 *
	 * @param isLandscape			boolean - optional - orentation is landscape (default: true)
	 * @returns {}
	 */
	getDimensions: function(isLandscape){
		var $environmentMeasurement;
		if(typeof(window) === 'undefined') return {};

		var data = {
			window: {
				width: 	0,
				height: 0
			},
			screen: {
				width:  window.screen.availWidth || window.screen.width,
				height: window.screen.availHeight || window.screen.height
			}
		};

		if(utils.$ && ($environmentMeasurement = utils.$('body > .environmentMeasurement').css('display', 'block')).length > 0){
			data.window = {
				width:  $environmentMeasurement.outerWidth(true),
				height: $environmentMeasurement.outerHeight(true)
			};
			$environmentMeasurement.css('display', 'none');
			if(
				(data.screen.width > data.screen.height && data.window.width < data.window.height)
				||
				(data.screen.width < data.screen.height && data.window.width > data.window.height)
			){
				data.screen = {
					width: 	data.screen.height,
					height: data.screen.width,
				};
				isLandscape = !isLandscape;
			}

			// flip isLandscape if measured data indicates a wrong value
			if(
				(
					!isLandscape
					&&
					data.window.width > data.window.height
				)
				||
				(
					isLandscape
					&&
					data.window.width < data.window.height
				)
			){
				isLandscape = !isLandscape;
			}
		}

		if(data.window.width <= 0 || data.window.height <= 0) {
			data.window = {
				width:  Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
				height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
			};
			if(data.window.width > data.screen.width || data.window.height > data.screen.height){
				data.window.width = data.screen.width;
				data.window.height = data.screen.height;
			}
		}


		data.isLandscape = isLandscape;

		if(window !== undefined){
			data.orientation = window.orientation;
		}

		// change values orientation dependent if necessary
		if(
			(
				!isLandscape
				&&
				data.window.width > data.window.height
			)
			||
			(
				isLandscape
				&&
				data.window.width < data.window.height
			)
		){
			data.screen = {
				width: 	data.screen.height,
				height: data.screen.width,
			};
			data.window = {
				width: 	data.window.height,
				height: data.window.width,
			};
		}

		return data;
	},

	/**
	 * this function returns the actual breakPoint according to the given environment-data and the available serviceMediaConfig.layout
	 *
	 * @param   environment     {} - actual users' environment
	 * @param   layouts         {} - layouts defined in serviceConfig
	 * @returns                 string - breakPoint (default: 'm')
	 */
	getBreakPoint: function(environment, layouts){
		var defaultBreakPoint = 'm';
		if(!environment || !environment.device || !environment.device.type || !layouts || !layouts[environment.device.type]) return defaultBreakPoint;
		if(!environment.dimensions || !environment.dimensions.window || !environment.dimensions.window.width) return defaultBreakPoint;

		var width = environment.dimensions.window.width;
		var takeMaxWidth = true;
		var actualBreakPoint = {
			width:  Number.MAX_SAFE_INTEGER,
			name:   defaultBreakPoint
		};
		var maxBreakPoint = {
			width:  -1,
			name:   defaultBreakPoint
		};

		// NOTE:    this breakPoint detection excludes the maxWidth configured for the actual breakPoint.
		//          this means: 768 <= m < 1024
		utils.forEach(layouts[environment.device.type], function(breakPointMaxWidth, breakPoint){
			if(width < breakPointMaxWidth){
				takeMaxWidth = false;
				if(breakPointMaxWidth <= actualBreakPoint.width){
					actualBreakPoint.width   = breakPointMaxWidth;
					actualBreakPoint.name       = breakPoint;
				}
			}
			else if(takeMaxWidth && maxBreakPoint.width < breakPointMaxWidth) {
				maxBreakPoint.width = breakPointMaxWidth;
				maxBreakPoint.name  = breakPoint;
			}
		});
		
		if(takeMaxWidth) return maxBreakPoint.name;
		return actualBreakPoint.name;
	},

	/**
	 * this function returns the actual style according to the given environment-data and the available serviceMediaConfig.style
	 * NOTE:    if the actual device is defined within the style-config as object containing a NON-complete list of
	 *          the available breakPoints within this device-layout, than the default style will be returned!
	 *
	 * @param   breakPoint      string - actual users' breakPoint
	 * @param   device          string - actual users' device
	 * @param   style           {} - style defined in serviceMediaConfig
	 * @returns                 string - style (default: 'desktop')
	 */
	getStyle: function(breakPoint, device, style){
		var actualStyle = 'desktop';
		if(!style) return actualStyle;
		breakPoint  = breakPoint || 'm';
		device      = device || 'desktop';

		if(typeof(style) === 'string'){
			actualStyle = style;
		}
		else if(style[device]){
			if(typeof(style[device]) === 'string') actualStyle = style[device];
			else if(style[device][breakPoint]) actualStyle = style[device][breakPoint];
		}

		return actualStyle;
	},

	/**
	 * this function returns the touchable eventName according to the given "normal" eventName
	 *
	 * @param   eventName       string - desktop event name
	 * @return  string - touchable event name or undefined in an error case
	 */
	getTouchableEvent: function(eventName){
		switch(eventName){
			case 'click': return 'tap';
		}

		return undefined;
	},

	keyboard: {
		// which keys are currently pressed
		activeKeyCodes: {},

		/**
		 * this function returns the code of a given keydown or keyup event.
		 * NOTE: the subset of supported keys is kept low sized on purpose.
		 *
		 * @param   event       Event - Dom-Key-Event
		 * @return  string      lower cased key code
		 */
		getKeyCode: function(event){
			if(event.which == 13)        return 'enter';
			else if(event.which == 27)   return 'esc';
			else if(event.which == 17)   return 'strg';

			return '';
		},

		/**
		 * this function is used to register a keyDown event identified by control key code
		 *
		 * @param keyCode       string - keyCode
		 */
		down: function(keyCode){
			if(keyCode) utils.keyboard.activeKeyCodes[keyCode] = true;
		},

		/**
		 * this function is used to register a keyUp event identified by control key code
		 *
		 * @param keyCode       string - keyCode
		 */
		up: function(keyCode){
			if(keyCode) utils.keyboard.activeKeyCodes[keyCode] = false;
		},

		/**
		 * this function is used to check if a control key code is currently pressed.
		 * NOTE: all arguments will be checked and corresponds to exactly one keyCode.
		 *
		 * @returns     boolean all keys given are pressed
		 */
		keysActive: function(){
			var k;
			var result = true;
			for(k in arguments){
				result &= utils.keyboard.activeKeyCodes[arguments[k]];
			}
			return result;
		}
	},


	///////////////////////////////////////////////
	///// LANGUAGE HELPERS
	///////////////////////////////////////////////

	i18next: {
		initialized:    false,
		wrapper:        null,
		core:           null,

		init: function(options){
			if(utils.i18next.wrapper !== null){
				var initResult = utils.i18next.wrapper.init(options);
				if(typeof(initResult.then) === 'function'){
					return initResult.then(function(core){
						utils.i18next.core = core;
						utils.i18next.initialized = true;
						return Promise.resolve();
					});
				}
				utils.i18next.core = initResult;
				utils.i18next.initialized = true;
			}
			return Promise.resolve();
		},

		__: function(){
			if(utils.i18next.initialized) return utils.i18next.core.t.apply(utils.i18next.core, arguments);
			return 'I18N-INIT-ERROR';
		}
	},

	///////////////////////////////////////////////
	///// MISCELANIOUS HELPERS
	///////////////////////////////////////////////

	md5: function(value){
		return crypto.createHash('md5').update(value).digest('hex');
	},
	moment: moment,
	initMoment: function(timeZone, locale){
		timeZone = timeZone || 'Europe/Vienna';
		locale = locale || 'de';
		this.moment.locale(locale);
		this.moment.tz.setDefault(timeZone);
		console.log('########### SET TIMEZONE: ' + timeZone + ' with locale ' + locale + ' ##############')
	},

	date: {
		format: function(date, format){
			// var date = new Date(date);
			var date = moment(date);
			switch(format){
				case 'dbDateTime':
					date = date.toISOString();
					// 	date.getFullYear() + '-' +
					// 	String(date.getMonth() + 1).padStart(2, '0') + '-' +
					// 	String(date.getDate()).padStart(2, '0') + ' ' +
					// 	String(date.getHours()).padStart(2, '0') + ':' +
					// 	String(date.getMinutes()).padStart(2, '0') + ':' +
					// 	String(date.getSeconds()).padStart(2, '0')
					// ;
					break;

				case 'dbDate':
					date = date.format('YYYY-MM-DD');
					// date =
					// 	date.getFullYear() + '-' +
					// 	String(date.getMonth() + 1).padStart(2, '0') + '-' +
					// 	String(date.getDate()).padStart(2, '0') + ' ' +
					// 	'00:00:00'
					// ;
					break;

				default:
					if(format) 	date = date.format(format);
					else 		date = date.format('YYYY-MM-DD');
					break;
			}

			return date;
		}
	},

	time: {
		diff: function(start, end){
			var s = utils.time.toMS(start || '');
			var e = utils.time.toMS(end || '');
			return e - s;
		},

		toMS: function(time){
			var parts = String(time || '').split(':');
			if(parts[2]){
				var sPart = String(parts[2] || '').split('.');
				parts[2] = sPart[0] || 0;
				parts[3] = sPart[1] || 0;
			}
			return (
				(((parts[0] * 1) || 0) * 3600000) +
				(((parts[1] * 1) || 0) * 60000) +
				(((parts[2] * 1) || 0) * 1000) +
				(((parts[3] * 1) || 0) * 1)
			);
		}
	},

	number: {
		format: function(value, format, fieldType = 'integer'){
			var originalValue = value;
			format = format || {}

			// default-config
			var conf = {
				locale: "de-DE",
				decimals: 0,
				decimalDigit: ",",
				thousandsDigit: "."
			};

			if(fieldType === 'float') {
				conf.decimals = 2;
			}

			if (format.locale !== undefined)			conf.locale = format.locale;
			if (format.decimals !== undefined)			conf.decimals = format.decimals;
			if (format.decimalDigit !== undefined)		conf.decimalDigit = format.decimalDigit;
			if (format.thousandsDigit !== undefined)	conf.thousandsDigit = format.thousandsDigit;

			// remove thousand-separator and replace decimal-point if input type is string (value is given formatted)
			if(typeof value === 'string'){
				if (conf.thousandsDigit === '.') 	value = value.replace(/\./g, '').replace(/,/g, '.');
				else 								value = value.replace(/,/g, '');
			}

			if(fieldType === 'integer') {
				value = parseInt(value, 10)
			} else if(fieldType === 'float') {
				value = parseFloat(value)
			}

			var formatted = new Intl.NumberFormat(conf.locale, { minimumFractionDigits: conf.decimals, maximumFractionDigits: conf.decimals }).format(value)
			formatted = `${format.prefix || ''}${formatted}${format.suffix || ''}`

			return {
				originalValue,
				value,
				formatted
			};
		}
	},

	fileSize: {

		/**
		 * transform a given fileSize to a human readable format.
		 *
		 * @param sizeInBytes			int - sizeInBytes
		 * @param fractionDigits		int - number of digits after comma
		 * @returns {string}			human readable fileSize
		 */
		format: function(sizeInBytes, fractionDigits){
			sizeInBytes = sizeInBytes || 0;
			var realSize, extension;

			if(sizeInBytes > 1099511627776){
				realSize = (sizeInBytes / 1125899906842624);
				extension = 'TB';
			} else if(sizeInBytes > 1073741824){
				realSize = (sizeInBytes / 1073741824);
				extension = 'GB';
			} else if(sizeInBytes > 1048576){
				realSize = (sizeInBytes / 1048576);
				extension = 'MB';
			} else if(sizeInBytes > 1024){
				realSize = (sizeInBytes / 1024);
				extension = 'KB';
			} else {
				realSize = sizeInBytes;
				extension = 'B';
			}

			return parseFloat(String(realSize || '0').trim().replace(/[^\d\.]/g, "")).toFixed(fractionDigits || 2).toString().replace('\.', ',').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.') + ' ' + extension;
		}
	},

	/**
	 * this function is used to build an md5 hash of recursive (as well as non-recursive) collections.
	 * the values are sorted by keys in an alphanumeric way so order differences does not matter.
	 * arrays and objects (empty or not) are processed distinct.
	 * the given value may be any value possible (primitive as well as arrays or objects).
	 * keys and values are handled case-sensitive.
	 *
	 * examples:
	 * 		String == Integer values are handled equal.
	 * 		'null' vs null values are handled equal.
	 * 		'undefined' vs undefined values are handled equal.
	 * 		'true' vs true values are handled equal.
	 * 		'True' vs true values are handled distinct.
	 *
	 * @param value		mixed
	 * @return String(32) md5 hash identifying the object
	 */
	collectionMD5: function(value){

		// md5 simple values
		if (value === null) {
			return utils.md5('null');
		}
		if (typeof value !== 'object') {
			return utils.md5(value);
		}

		var newValue, i;
		// md5 array
		if (value instanceof Array) {
			var l;
			newValue = [];
			for (i = 0, l = value.length; i < l; i++) {
				if (value[i] === null) {
					newValue.push(i + ':null');
				} else if (typeof value[i] !== 'object') {
					newValue.push(i + ':' + value[i]);
				} else {
					newValue.push(i + ':' + utils.collectionMD5(value[i]));
				}
			}
			return utils.md5('a|' + newValue.join(';'));
		}

		// md5 object
		newValue = [];
		for (i in value) {
			if (value.hasOwnProperty(i)) {
				if (value[i] === null) {
					newValue.push(i + ':null');
				} else if (typeof value[i] !== 'object') {
					newValue.push(i + ':' + value[i]);
				} else {
					newValue.push(i + ':' + utils.collectionMD5(value[i]));
				}
			}
		}

		if(newValue.length > 0){
			newValue.sort(function(a, b){
				if(a < b) return 1;
				if(a > b) return -1;
				return 0;
			});
		}

		return utils.md5('o|' + newValue.join(';'));
	},

	truncateStringByBytes: truncateStringByBytes.bind(null, getLength),

	nameSeoToPath: function(input){
		// sanitize by "npm i sanitize-filename truncate-utf8-bytes lodash/kebabCase"
		if(!input) return '';

		return kebabCase(
			this.truncateStringByBytes(
				String(input)
					.toLowerCase()
					.replace(/ä/g, 'ae')
					.replace(/ö/g, 'oe')
					.replace(/ü/g, 'ue')
					.replace(/ß/g, 'ss')
					.replace(/[\/\?<>\\:\*\|"]/g, '')
					.replace(/[\x00-\x1f\x80-\x9f]/g, '')
					.replace(/^\.+$/, '')
					.replace(/^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i, '')
					.replace(/[\. ]+$/, '')
				, 255
			)
		);
	},





	///////////////////////////////////////////////
	///// DEBUG HELPERS
	///////////////////////////////////////////////

	debug: {}
};

/**
 * this is the internal function used for referential simple copies made by utils.refSimpleCopy()
 *
 * @param refTarget			mixed - referenced target
 * @param value				mixed - value to copy
 * @param index				mixed - index in referential target to copy value to.
 * @returns {{}|Array|*}
 */
var refSimpleCopy = function(refTarget, value, index) {
	// copy simple value
	if (typeof value !== 'object' || value === null) {
		refTarget[index] = value;
		return;
	}

	var i;
	// copy array
	if (value instanceof Array) {
		var l;
		if(!(refTarget[index] instanceof Array)){
			refTarget[index] = [];
		}
		for (i = 0, l = value.length; i < l; i++) {
			refSimpleCopy(refTarget[index], value[i], i);
		}
		return;
	}

	// copy object
	if(!refTarget[index] || typeof refTarget[index] !== 'object'){
		refTarget[index] = {};
	}
	for (i in value) {
		if (value.hasOwnProperty(i)) {
			refSimpleCopy(refTarget[index], value[i], i);
		}
	}
};

// set up override elements to prevent client side errors
utils.debug.timeMeasurement = {
	forceRelationKey: '',
	set: function(){},
	toString: function(){}
}

module.exports = utils;